import React from "react";
import styled from "styled-components";

import * as u from "../utils";

export function AllBright(props) {
  return (
    <S.Svg
      width={props.width ?? "137"}
      height={props.height ?? "17"}
      viewBox="0 0 137 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={props.colour ?? u.colours.charcoal}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.002 0.456692C12.1736 5.81447 14.3414 11.1807 16.5299 16.5235C15.3194 16.5892 13.9755 16.5338 12.7129 16.5521C12.2906 15.4168 11.8481 14.3026 11.4291 13.1686H5.01346C4.51602 14.2448 4.11674 15.4186 3.67378 16.5521H0C2.19741 11.1948 4.34175 5.78817 6.55842 0.456692H10.002ZM136.077 14.6362C136.097 16.068 134.602 16.9698 133.354 16.3667C132.632 16.0125 132.227 15.1595 132.335 14.3539C132.452 13.5164 133.086 12.9621 133.885 12.8399C135.151 12.6488 136.064 13.5943 136.077 14.6362ZM105.61 0.459886V6.67117H112.521C112.591 4.6593 112.531 2.52108 112.551 0.459886H116.107V16.5562H112.551V9.79114H105.61V16.5562H102.054V0.548196C102.053 0.50686 102.049 0.465993 102.082 0.459886H105.61ZM133.115 0.459886V3.57985H127.925C127.858 7.84926 127.915 12.2408 127.896 16.5562H124.339V3.61133C122.666 3.53946 120.87 3.59911 119.149 3.57985V0.548196C119.147 0.50686 119.144 0.465993 119.178 0.459886H133.115ZM81.0813 0.459886V16.5562H77.5259V0.548196C77.5245 0.50686 77.5188 0.465993 77.5545 0.459886H81.0813ZM23.1679 0.459886V13.4043C25.4611 13.4767 27.883 13.4156 30.2261 13.4367V16.5562H19.6101V0.548196C19.6077 0.50686 19.6059 0.465993 19.6402 0.459886H23.1679ZM36.6283 0.459886V13.4043C38.923 13.4767 41.3445 13.4156 43.6884 13.4367V16.5562H33.0734V0.548196C33.072 0.50686 33.0682 0.465993 33.1049 0.459886H36.6283ZM72.3116 1.77425C73.4437 2.64513 74.0491 4.1666 73.827 6.00185C73.6024 7.86763 72.3666 9.20684 70.6483 9.73341C72.0147 11.9905 73.7358 14.3077 75.1112 16.5558H71.0856C69.6412 14.5007 68.3677 12.2784 66.9449 10.197H65.43V16.5558H61.8736V0.548243C61.8718 0.506907 61.8685 0.46604 61.9018 0.459933C65.8274 0.53556 70.0155 0.00429191 72.3116 1.77425ZM98.449 1.20737V4.73648C98.3015 4.76466 98.0868 4.58757 97.8933 4.47578C96.6259 3.7242 94.8395 2.98484 92.7337 3.25118C90.6932 3.50343 89.1807 4.75057 88.5634 6.51583C87.81 8.67707 88.5705 10.9731 89.8195 12.1146C91.0676 13.256 93.3993 13.9254 95.5037 13.1358V10.7148H92.7055V7.76861H98.9727V15.2641C96.5639 16.7706 92.0921 17.0148 89.2939 15.7024C86.6723 14.4665 84.6956 11.9925 84.6876 8.38208C84.6802 5.79009 85.7417 3.79936 87.1359 2.43338C88.5817 1.01619 90.4311 0.13732 93.0827 0.0123713C95.2651 -0.0886214 96.9966 0.439359 98.449 1.20737ZM57.1746 1.86791C57.7749 2.40482 58.1606 3.23812 58.225 4.10995C58.3649 6.00485 57.3264 7.2675 55.8044 7.72831C57.3597 8.28118 58.465 9.05577 58.7788 10.7604C59.5139 14.7898 56.2356 16.253 52.7436 16.5039C50.9004 16.6354 48.8284 16.4663 46.7959 16.5335V0.527293C46.7926 0.483138 46.7907 0.442271 46.8241 0.439453C50.7177 0.505685 55.0871 -0.00491493 57.1746 1.86791ZM50.3809 9.53584C50.3475 9.54101 50.3494 9.58093 50.3513 9.62039V13.4999C52.11 13.4064 54.1965 13.7216 54.988 12.7145C55.6123 11.9169 55.2957 10.5439 54.6376 10.061C53.7061 9.37425 51.9141 9.55698 50.3809 9.53584ZM8.19403 4.5382C7.55096 6.5388 6.77778 8.40693 6.09244 10.3699C7.50352 10.3507 8.98741 10.4103 10.3487 10.3394C9.59196 8.44639 8.96016 6.42512 8.19403 4.5382ZM65.4587 3.5799C65.4258 3.58601 65.4272 3.62875 65.43 3.66727V7.54727C66.9369 7.51157 68.736 7.69336 69.6567 7.02352C70.2142 6.61626 70.5651 5.54527 70.1551 4.68659C69.5388 3.40563 67.3935 3.60527 65.4587 3.5799ZM50.3809 3.47111C50.3475 3.47393 50.3494 3.51668 50.3513 3.55848V7.0843C51.8441 7.09041 53.569 7.23274 54.2867 6.41681C54.7733 5.8644 54.8231 4.70792 54.2867 4.13954C53.5464 3.34992 51.9188 3.51433 50.3809 3.47111Z"
      />
    </S.Svg>
  );
}

export function AllBrightPlus(props) {
  return (
    <S.Svg
      width={props.width ?? "137"}
      height={props.height ?? "17"}
      viewBox="0 0 1536.2 207.06"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <polygon
        fill={
          props.colour ?? props.invertedPlus
            ? u.colours.plusLime
            : u.colours.charcoal
        }
        points="1489.69 91.08 1489.69 115.98 1445.23 115.98 1445.23 160.44 1420.11 160.44 1420.11 115.98 1375.64 115.98 1375.64 91.08 1420.11 91.08 1420.11 46.61 1445.23 46.61 1445.23 91.08 1489.69 91.08"
      />
      <path
        fill={props.invertedPlus ? u.colours.charcoal : u.colours.plusLime}
        d="M1432.67,0c-57.18,0-103.53,46.35-103.53,103.53s46.35,103.53,103.53,103.53,103.53-46.35,103.53-103.53S1489.85,0,1432.67,0Zm57.02,115.98h-44.46v44.46h-25.12v-44.46h-44.47v-24.9h44.47V46.61h25.12v44.47h44.46v24.9Z"
      />
      <path
        fill={props.colour ?? u.colours.charcoal}
        fillRule="evenodd"
        d="M933.09,41.21v31.51c-1.26,.25-3.1-1.32-4.77-2.3-10.92-6.69-26.36-13.24-44.48-10.89-17.61,2.25-30.65,13.34-35.96,28.99-6.51,19.2,.05,39.59,10.82,49.71,10.75,10.15,30.85,16.09,49.01,9.06v-21.48h-25.38v-25.38h54.99v65.55c-21.39,13.37-61.11,15.53-85.97,3.87-23.28-10.96-40.82-32.94-40.89-64.98-.07-23.04,9.34-40.72,21.74-52.85,12.84-12.57,29.26-20.37,52.8-21.48,19.42-.89,34.75,3.8,47.67,10.62"
      />
      <path
        fill={props.colour ?? u.colours.charcoal}
        fillRule="evenodd"
        d="M57.46,34.87h31.55c19.16,47.24,38.28,94.57,57.58,141.67-10.67,.6-22.53,.11-33.67,.27-3.7-10.01-7.6-19.85-11.3-29.84H44.41c-4.34,9.42-7.83,19.69-11.72,29.61H0C19.49,129,38.53,80.99,58.22,33.64m-4.11,88.87c12.51-.15,25.69,.36,37.78-.25-6.7-16.81-12.33-34.77-19.13-51.52-5.7,17.76-12.57,34.34-18.65,51.77"
      />
      <path
        fill={props.colour ?? u.colours.charcoal}
        fillRule="evenodd"
        d="M178.02,34.87h31.73v114.97c20.63,.62,42.38,.11,63.45,.29v26.45h-95.18V35.29c0-.37-.04-.73,.27-.79"
      />
      <path
        fill={props.colour ?? u.colours.charcoal}
        fillRule="evenodd"
        d="M313.38,34.87h29.61v114.97c20.63,.62,42.38,.11,63.45,.29v26.45h-95.18V35.29c0-.37-.03-.73,.29-.79"
      />
      <path
        fill={props.colour ?? u.colours.charcoal}
        fillRule="evenodd"
        d="M444.75,34.34c34.57,.56,73.41-3.97,91.93,12.68,5.32,4.77,8.73,12.16,9.32,19.91,1.24,16.81-7.97,28.02-21.48,32.12,13.79,4.92,23.62,11.8,26.42,26.93,6.52,35.81-22.58,48.78-53.6,51.01-16.37,1.17-34.78-.33-52.82,.27V35.11c-.04-.4-.04-.75,.24-.77m31.49,28.02v30.99c13.23,.04,28.54,1.32,34.93-5.92,4.31-4.93,4.75-15.2,0-20.24-6.58-7.02-21.05-5.55-34.68-5.96-.31,.04-.25,.42-.25,.81m0,53.2v35.07c15.6-.84,34.13,1.98,41.16-6.98,5.56-7.09,2.72-19.28-3.1-23.57-8.28-6.08-24.17-4.46-37.8-4.64-.31,.04-.25,.37-.25,.73"
      />
      <path
        fill={props.colour ?? u.colours.charcoal}
        fillRule="evenodd"
        d="M586.48,34.12c35.01,.68,72.39-4.08,92.89,11.81,10.07,7.83,15.49,21.5,13.5,37.97-2.02,16.76-13.05,28.8-28.35,33.53,12.19,20.25,27.53,41.07,39.8,61.26h-35.91c-12.9-18.46-24.24-38.43-36.92-57.11h-13.54v57.11h-31.73V34.92c-.04-.37-.04-.74,.26-.8m31.47,28.24v35.1c13.39-.34,29.38,1.3,37.54-4.66,4.93-3.62,8.06-13.12,4.44-20.76-5.5-11.36-24.53-9.61-41.72-9.83-.27,.05-.27,.44-.26,.77"
      />
      <path
        fill={props.colour ?? u.colours.charcoal}
        fillRule="evenodd"
        d="M740.62,34.87h31.73V178.69h-31.73V35.66c0-.37-.07-.74,.26-.79"
      />
      <path
        fill={props.colour ?? u.colours.charcoal}
        fillRule="evenodd"
        d="M983.86,34.87h31.73v54.99h61.27c.6-17.81,.07-36.74,.26-54.99h31.53V176.57h-31.73v-59.22h-61.34v59.22h-31.73V35.29c0-.37,0-.73,.26-.79"
      />
      <path
        fill={props.colour ?? u.colours.charcoal}
        fillRule="evenodd"
        d="M1146.72,34.87h122.67v27.5h-44c-.63,37.59-.11,76.23-.29,114.21h-31.85V62.65c-15.01-.65-31.08-.11-46.53-.29v-27.07c0-.37-.04-.73,.27-.79"
      />
    </S.Svg>
  );
}

export function AllBrightVector(props) {
  return (
    <S.Svg
      width={props.width ?? "200"}
      height={props.height ?? "200"}
      viewBox="0 0 1903 1716"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1902 1696.88V1690.97C1744.73 1690.97 1657.3 1557.95 1532.72 1285.17L949.464 0L423.753 1227.8H431.854L733.257 524.755L1067.62 1306.26C1151.7 1502.84 1174.61 1691.25 967.062 1691.25V1697.16H1902.28L1902 1696.88ZM285.482 1412.28C72.0688 1293.05 0 1469.93 0 1555.42C0 1640.91 103.354 1715.72 253.917 1715.72C413.418 1715.72 644.987 1633.88 782.141 1510.99L776.555 1507.05C605.88 1628.54 325.706 1434.5 285.482 1412"
        fill={props.colour || u.colours.shell}
      />
    </S.Svg>
  );
}

export function LoadingVector(props) {
  return (
    <S.Svg
      data-cy={props.dataCy}
      width={props.width ?? "200"}
      height={props.height ?? "200"}
      viewBox="0 0 1903 1716"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="logo-gradient"
          gradientUnits="objectBoundingBox"
          x1="0"
          y1="0"
          x2="1"
          y2="1"
        >
          <stop offset="0" stopColor="#083D39">
            <animate
              attributeName="stop-color"
              values="#083D39;#2C736F;#083D39;"
              dur="5s"
              repeatCount="indefinite"
            ></animate>
          </stop>

          <stop offset="1" stopColor="#2C736F">
            <animate
              attributeName="stop-color"
              values="#2C736F;#083D39;#2C736F;"
              dur="5s"
              repeatCount="indefinite"
            ></animate>
          </stop>
          <animateTransform
            attributeName="gradientTransform"
            type="rotate"
            from="0 1 -.5"
            to="360 1 -.5"
            dur="5s"
            repeatCount="indefinite"
          />
        </linearGradient>
      </defs>
      <path
        d="M1902 1696.88V1690.97C1744.73 1690.97 1657.3 1557.95 1532.72 1285.17L949.464 0L423.753 1227.8H431.854L733.257 524.755L1067.62 1306.26C1151.7 1502.84 1174.61 1691.25 967.062 1691.25V1697.16H1902.28L1902 1696.88ZM285.482 1412.28C72.0688 1293.05 0 1469.93 0 1555.42C0 1640.91 103.354 1715.72 253.917 1715.72C413.418 1715.72 644.987 1633.88 782.141 1510.99L776.555 1507.05C605.88 1628.54 325.706 1434.5 285.482 1412"
        fill="url('#logo-gradient')"
      />
    </S.Svg>
  );
}

export function Ambassador(props) {
  const size = props.size || 21;
  return (
    <img src="/images/ambassador.png" width={size} alt="allbright ambassador" />
  );
}

export function Arrow(props) {
  return (
    <S.Svg
      viewBox="0 0 17 17"
      color="rgba(65, 65, 67, 1)"
      width="14.4"
      height="14.4"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.5.5L7.09 1.91l5.58 5.59H.5v2h12.17l-5.58 5.59L8.5 16.5l8-8-8-8z"
      />
    </S.Svg>
  );
}

export function ArrowDown(props) {
  return (
    <S.Svg
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={props.colour || "rgba(65, 65, 67, 1)"}
      width="12"
      height="12"
      {...props}
    >
      <path
        d="M1.41.295L6 4.875l4.59-4.58L12 1.705l-6 6-6-6L1.41.295z"
        fill="currentColor"
      ></path>
    </S.Svg>
  );
}

export function ArrowLeft(props) {
  return (
    <S.Svg
      width={props.width || "25"}
      height={props.height || "25"}
      viewBox="0 0 25 25"
      fill={props.colour}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        transform="rotate(180 12.5 12.5)"
        d="M12.5 4.5L11.09 5.91L16.67 11.5H4.5V13.5H16.67L11.09 19.09L12.5 20.5L20.5 12.5L12.5 4.5Z"
        fill={props.colour || "white"}
      />
    </S.Svg>
  );
}

export function ArrowRight(props) {
  return (
    <S.Svg
      width={props.width || "25"}
      height={props.height || "25"}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 4.5L11.09 5.91L16.67 11.5H4.5V13.5H16.67L11.09 19.09L12.5 20.5L20.5 12.5L12.5 4.5Z"
        fill={props.colour || "white"}
      />
    </S.Svg>
  );
}

export function ArrowTall(props) {
  return (
    <S.Svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      xmlns={"http://www.w3.org/2000/S.Svg"}
      {...props}
    >
      <path
        d="M1.146 14.5816C1.04599 14.6788 0.984174 14.8142 0.983791 14.9646M1.146 14.5816L7.65523 8.07235L7.58452 8.00164M1.146 14.5816L1.07529 14.5109L1.07577 14.5104M1.146 14.5816L1.0763 14.5099C1.07613 14.51 1.07595 14.5102 1.07577 14.5104M0.983791 14.9646L0.983791 14.966C0.98455 15.2607 1.22383 15.5 1.51919 15.5C1.66968 15.5 1.80564 15.4381 1.90315 15.3378L8.86143 8.37951C8.95847 8.28247 9.01848 8.14885 9.01848 8.00117C9.01848 7.85349 8.95847 7.71941 8.86143 7.62283M0.983791 14.9646H0.983789H0.883789M0.983791 14.9646L1.97486 15.4075C1.97469 15.4077 1.97452 15.4078 1.97434 15.408M7.58452 8.00164L7.65523 7.93093L1.146 1.42171M7.58452 8.00164L1.07577 14.5104M7.58452 8.00164L1.07591 1.49304M1.146 1.42171C1.04474 1.32419 0.981445 1.18729 0.981445 1.0354C0.981445 0.739569 1.22101 0.5 1.51684 0.5C1.66874 0.5 1.80564 0.563291 1.90315 0.664557M1.146 1.42171L1.07664 1.49374C1.0764 1.49351 1.07616 1.49327 1.07591 1.49304M1.146 1.42171L1.07529 1.49242L1.07591 1.49304M1.90315 0.664557L8.86143 7.62283M1.90315 0.664557L1.97386 0.593845L1.9745 0.594482M1.90315 0.664557L1.97518 0.595192C1.97496 0.594955 1.97473 0.594719 1.9745 0.594482M8.86143 7.62283L8.93197 7.55195M8.86143 7.62283L8.93214 7.55212L8.93197 7.55195M0.883789 14.9646C0.884173 14.7865 0.957411 14.6257 1.07577 14.5104M0.883789 14.9646C0.883789 14.9648 0.88379 14.9651 0.88379 14.9653L1.97434 15.408M0.883789 14.9646V14.966H0.883791C0.88455 15.3159 1.16854 15.6 1.51919 15.6C1.69745 15.6 1.85876 15.5267 1.97434 15.408M1.07591 1.49304C0.956399 1.37759 0.881445 1.21534 0.881445 1.0354C0.881445 0.68434 1.16579 0.4 1.51684 0.4C1.69679 0.4 1.85905 0.474959 1.9745 0.594482M1.9745 0.594482L8.93197 7.55195M8.93197 7.55195C9.04717 7.6666 9.11848 7.82592 9.11848 8.00117C9.11848 8.17656 9.04708 8.33528 8.93214 8.45022L1.97434 15.408"
        strokeWidth="0.9"
        fill={props.fill}
        stroke={props.fill}
      />
    </S.Svg>
  );
}

export function ArrowShort(props) {
  return (
    <S.Svg width="8" height="12" viewBox="0 0 8 12" fill="none" {...props}>
      <path
        d="M0.589844 10.59L5.16984 6L0.589844 1.41L1.99984 0L7.99984 6L1.99984 12L0.589844 10.59Z"
        fill={u.colours.charcoal}
      />
    </S.Svg>
  );
}

export function ArrowUp(props) {
  return (
    <S.Svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="rgba(65, 65, 67, 1)"
      {...props}
    >
      <path d="M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z" />
    </S.Svg>
  );
}

export function ArrowWhite(props) {
  return (
    <S.Svg
      viewBox="0 0 17 17"
      xmlns="http://www.w3.org/2000/svg"
      color="rgba(255, 255, 255, 1)"
      width="17"
      height="17"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.5.5L7.09 1.91l5.58 5.59H.5v2h12.17l-5.58 5.59L8.5 16.5l8-8-8-8z"
      ></path>
    </S.Svg>
  );
}

export function Back(props) {
  return (
    <S.Svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="32" height="32" rx="16" fill="#F3E9E2" />
      <path
        d="M16 21.5L17.0575 20.4425L12.8725 16.25H22V14.75H12.8725L17.0575 10.5575L16 9.5L10 15.5L16 21.5Z"
        fill="#404043"
      />
    </S.Svg>
  );
}

export function Bell(props) {
  return (
    <S.Svg viewBox="0 0 24 24" fill="none" width="20" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10.75v5l2 2v1H4v-1l2-2v-5c0-3.08 1.64-5.64 4.5-6.32v-.68c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.68c2.87.68 4.5 3.25 4.5 6.32zm-4 9c0 1.1-.9 2-2 2s-2-.9-2-2h4z"
        fill="currentColor"
      />
    </S.Svg>
  );
}

export function Benefit(props) {
  return (
    <S.Svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 112.82 37.41"
      {...props}
    >
      <g id="Layer_2-2">
        <path d="m32.17,25.56c-3.32,0-5.89-2.44-5.89-7.93v-.14h11.88c-.32-4.7-3.32-7.68-7.47-7.68-4.49,0-8.01,3.79-8.01,9.16s3.61,8.72,8.29,8.72c3.9,0,6.71-2.33,7.54-6.53h-.9c-.9,2.98-2.71,4.42-5.46,4.42Zm-1.69-14.65c2.17,0,3.52,1.51,3.75,5.46h-7.9c.29-3.68,1.94-5.46,4.15-5.46Z" />
        <path d="m12.8,9.8c-2.53,0-4.65,1.2-6.16,3.36V0c-1.02.57-2.1.83-3.88.83H0v1.11h3.23v20.54c0,1.62-.05,2.71-.16,3.73H0v1.11h6.25c.16-.86.27-1.76.29-2.62.93,1.96,2.89,2.98,5.28,2.98,4.83,0,8.4-4.13,8.4-9.53,0-4.88-2.73-8.35-7.41-8.35Zm-1.2,16.69c-3.03,0-4.95-2.12-4.95-5.82v-6.52c1.22-1.6,2.84-2.46,4.63-2.46,3.14,0,5.33,2.6,5.33,7.79,0,4.65-2.12,7-5.01,7Z" />
        <path d="m57.46,15.03c0-3.05-1.8-5.22-5.46-5.22-2.46,0-4.43,1.18-6.1,3.34v-3.34c-1.02.57-2.1.83-3.88.83h-2.58v1.11h3.05v14.47h-3.05v1.11h9.23v-1.11h-2.76v-12.15c1.31-1.54,2.98-2.33,4.72-2.33,2.3,0,3.43,1.36,3.43,3.64v10.84h-2.76v1.11h9.19v-1.11h-3.02v-11.18Z" />
        <path d="m111.96,22.87c-.39,1.74-1.44,2.8-3.09,2.8s-2.59-.88-2.59-2.71v-11.22h5.96v-1.11h-5.96v-5.06h-1.11v.32c0,3.18-1.31,4.74-4.76,4.74h-1.13v1.11h3.59v11.6c0,2.69,1.63,4.34,4.7,4.34,2.91,0,4.76-1.81,5.24-4.81h-.86Z" />
        <path d="m77.08,21.15h-.9c-.9,2.98-2.71,4.42-5.46,4.42-3.32,0-5.89-2.44-5.89-7.93v-.14h11.88c-.32-4.7-3.32-7.68-7.47-7.68-4.49,0-8.01,3.79-8.01,9.16s3.61,8.72,8.29,8.72c3.9,0,6.71-2.33,7.54-6.53Zm-8.04-10.23c2.17,0,3.52,1.51,3.75,5.46h-7.9c.29-3.68,1.94-5.46,4.15-5.46Z" />
        <path d="m96.67,9.8c-1.02.57-2.1.83-3.88.83h-5.76c.29-1.02.57-2.06.88-3.09,1.31-4.51,2.96-5.96,5.35-5.96.99,0,1.72.29,2.21.75-.25-.11-.52-.18-.84-.18-1.18,0-1.94.9-1.94,1.94,0,1.15.86,2.01,2.08,2.01,1.36,0,2.26-1.01,2.26-2.37,0-1.72-1.2-3.2-3.84-3.2-4.11,0-7.63,3.55-9.68,10.09h-5.44v1.11h5.1c-1.72,6.18-3.14,12.44-4.9,18.6-1.35,4.67-3,6.03-5.26,6.03-.84,0-1.51-.22-1.96-.57.22.09.47.14.74.14,1.13,0,1.94-.83,1.94-1.94s-.79-2.01-2.08-2.01-2.26,1.04-2.26,2.33c0,1.85,1.45,3.09,3.63,3.09,3.84,0,7.47-3.09,9.95-11.49,1.38-4.69,2.51-9.46,3.77-14.18h6.53v14.47h-3.05v1.11h9.51v-1.11h-3.05V9.8Z" />
      </g>
    </S.Svg>
  );
}

export function Bin(props) {
  return (
    <S.Svg
      viewBox="0 0 24 24"
      color="rgb(224, 36, 94)"
      width="20"
      height="20"
      {...props}
    >
      <g>
        <path d="M20.746 5.236h-3.75V4.25c0-1.24-1.01-2.25-2.25-2.25h-5.5c-1.24 0-2.25 1.01-2.25 2.25v.986h-3.75c-.414 0-.75.336-.75.75s.336.75.75.75h.368l1.583 13.262c.216 1.193 1.31 2.027 2.658 2.027h8.282c1.35 0 2.442-.834 2.664-2.072l1.577-13.217h.368c.414 0 .75-.336.75-.75s-.335-.75-.75-.75zM8.496 4.25c0-.413.337-.75.75-.75h5.5c.413 0 .75.337.75.75v.986h-7V4.25zm8.822 15.48c-.1.55-.664.795-1.18.795H7.854c-.517 0-1.083-.246-1.175-.75L5.126 6.735h13.74L17.32 19.732z"></path>
        <path d="M10 17.75c.414 0 .75-.336.75-.75v-7c0-.414-.336-.75-.75-.75s-.75.336-.75.75v7c0 .414.336.75.75.75zm4 0c.414 0 .75-.336.75-.75v-7c0-.414-.336-.75-.75-.75s-.75.336-.75.75v7c0 .414.336.75.75.75z"></path>
      </g>
    </S.Svg>
  );
}

export function Bookmark(props) {
  return (
    <S.Svg
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.5 17.4998V0.499756H14.5V17.4998L7.5 13.4734L0.5 17.4998Z"
        stroke={u.colours.charcoal}
      />
    </S.Svg>
  );
}

export function Burger(props) {
  return (
    <S.Svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color="rgba(65, 65, 67, 1)"
      width="24"
      height="24"
      {...props}
    >
      <path
        d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
        fill="currentColor"
      ></path>
    </S.Svg>
  );
}

export function BurgerNav() {
  return (
    <S.Svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 9C5 8.44772 5.44772 8 6 8H24C24.5523 8 25 8.44772 25 9C25 9.55228 24.5523 10 24 10H6C5.44772 10 5 9.55228 5 9ZM5 15C5 14.4477 5.44772 14 6 14H24C24.5523 14 25 14.4477 25 15C25 15.5523 24.5523 16 24 16H6C5.44772 16 5 15.5523 5 15ZM6 20C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22H24C24.5523 22 25 21.5523 25 21C25 20.4477 24.5523 20 24 20H6Z"
        fill="currentColor"
      />
    </S.Svg>
  );
}

export function Close(props) {
  return (
    <S.Svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      style={{ transform: `rotate(45deg) scale(${props.grow || 1})` }}
      {...props}
    >
      <path
        d="M19 12a1 1 0 01-1 1h-5v5a1 1 0 11-2 0v-5H6a1 1 0 110-2h5V6a1 1 0 112 0v5h5a1 1 0 011 1z"
        fill="currentColor"
      />
    </S.Svg>
  );
}

export function Camera(props) {
  return (
    <S.Svg
      viewBox="0 0 36 32"
      color="rgba(65, 65, 67, 1)"
      width="20"
      height="20"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75.25h10.5l3.203 3.5H32a3.51 3.51 0 013.5 3.5v21a3.51 3.51 0 01-3.5 3.5H4a3.51 3.51 0 01-3.5-3.5v-21A3.51 3.51 0 014 3.75h5.547L12.75.25zm12.163 7l-3.203-3.5h-7.42l-3.202 3.5H4v21h28v-21h-7.087zM18 12.5c2.887 0 5.25 2.363 5.25 5.25S20.887 23 18 23s-5.25-2.363-5.25-5.25S15.113 12.5 18 12.5zm-8.75 5.25C9.25 12.92 13.17 9 18 9s8.75 3.92 8.75 8.75S22.83 26.5 18 26.5s-8.75-3.92-8.75-8.75z"
        fill="currentColor"
      />
    </S.Svg>
  );
}

export function PlayCircle(props) {
  return (
    <S.Svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="path-1-inside-1_104_27" fill="white">
        <path d="M109 66C109 90.8528 88.8528 111 64 111C39.1472 111 19 90.8528 19 66C19 41.1472 39.1472 21 64 21C88.8528 21 109 41.1472 109 66Z" />
      </mask>
      <path
        d="M101 66C101 86.4345 84.4345 103 64 103V119C93.2711 119 117 95.2711 117 66H101ZM64 103C43.5655 103 27 86.4345 27 66H11C11 95.2711 34.7289 119 64 119V103ZM27 66C27 45.5655 43.5655 29 64 29V13C34.7289 13 11 36.7289 11 66H27ZM64 29C84.4345 29 101 45.5655 101 66H117C117 36.7289 93.2711 13 64 13V29Z"
        fill={props.colour || "rgba(65, 65, 67, 1)"}
        mask="url(#path-1-inside-1_104_27)"
      />
      <path
        d="M80.5 67.366L54.25 82.5215C53.5833 82.9064 52.75 82.4252 52.75 81.6554L52.75 51.3446C52.75 50.5747 53.5833 50.0936 54.25 50.4785L80.5 65.634C81.1667 66.0189 81.1667 66.9811 80.5 67.366Z"
        stroke={props.colour || "rgba(65, 65, 67, 1)"}
        strokeWidth="8"
      />
    </S.Svg>
  );
}

export function Chat(props) {
  return (
    <S.Svg
      width={props.width || "44"}
      height={props.height || "44"}
      viewBox="0 0 44 36"
      fill={props.colour || "none"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props.alt}</title>
      <path
        d="M29.4947 7.71429C28.952 7.71429 28.4093 7.75286 27.8813 7.80429C25.6813 3.22714 20.5187 0 14.5053 0C6.512 0 0 5.70857 0 12.7157V27C0 27.4629 0.278667 27.8871 0.748 28.1186C0.968 28.2343 1.21733 28.2857 1.46667 28.2857C1.73067 28.2857 1.99467 28.2214 2.21467 28.1057L9.07867 24.5057C10.8093 25.1229 12.6427 25.4314 14.5053 25.4314C15.048 25.4314 15.5907 25.4057 16.1187 25.3414C18.3627 30.0471 23.584 33.1457 29.4947 33.1457C31.3573 33.1457 33.176 32.8371 34.9213 32.22L41.7853 35.82C42.02 35.9357 42.284 36 42.5333 36C42.7827 36 43.032 35.9486 43.252 35.8329C43.7067 35.6014 44 35.1771 44 34.7143V20.43C44 13.4229 37.488 7.71429 29.4947 7.71429ZM9.592 21.8829C9.152 21.7029 8.63867 21.7286 8.21333 21.9471L2.93333 24.7243V12.7029C2.93333 7.11 8.12533 2.55857 14.5053 2.55857C20.8853 2.55857 26.0773 7.11 26.0773 12.7029C26.0773 18.2957 20.8853 22.8471 14.5053 22.8471C12.804 22.8471 11.1613 22.5257 9.592 21.8829ZM41.0667 32.4386L35.7867 29.6614C35.3613 29.4429 34.848 29.4171 34.408 29.5971C32.8533 30.24 31.196 30.5614 29.4947 30.5614C24.9627 30.5614 20.9587 28.2729 19.052 24.7629C24.816 23.0786 28.996 18.3214 28.996 12.7029C28.996 11.88 28.8933 11.0829 28.732 10.3114C28.813 10.3073 28.894 10.3017 28.9755 10.2961C29.1449 10.2846 29.3164 10.2729 29.4947 10.2729C35.8747 10.2729 41.0667 14.8243 41.0667 20.4171V32.4386Z"
        fill={props.colour || "#FFFBF9"}
      />
      <path
        d="M29.4947 7.71429C28.952 7.71429 28.4093 7.75286 27.8813 7.80429C25.6813 3.22714 20.5187 0 14.5053 0C6.512 0 0 5.70857 0 12.7157V27C0 27.4629 0.278667 27.8871 0.748 28.1186C0.968 28.2343 1.21733 28.2857 1.46667 28.2857C1.73067 28.2857 1.99467 28.2214 2.21467 28.1057L9.07867 24.5057C10.8093 25.1229 12.6427 25.4314 14.5053 25.4314C15.048 25.4314 15.5907 25.4057 16.1187 25.3414C18.3627 30.0471 23.584 33.1457 29.4947 33.1457C31.3573 33.1457 33.176 32.8371 34.9213 32.22L41.7853 35.82C42.02 35.9357 42.284 36 42.5333 36C42.7827 36 43.032 35.9486 43.252 35.8329C43.7067 35.6014 44 35.1771 44 34.7143V20.43C44 13.4229 37.488 7.71429 29.4947 7.71429ZM9.592 21.8829C9.152 21.7029 8.63867 21.7286 8.21333 21.9471L2.93333 24.7243V12.7029C2.93333 7.11 8.12533 2.55857 14.5053 2.55857C20.8853 2.55857 26.0773 7.11 26.0773 12.7029C26.0773 18.2957 20.8853 22.8471 14.5053 22.8471C12.804 22.8471 11.1613 22.5257 9.592 21.8829ZM41.0667 32.4386L35.7867 29.6614C35.3613 29.4429 34.848 29.4171 34.408 29.5971C32.8533 30.24 31.196 30.5614 29.4947 30.5614C24.9627 30.5614 20.9587 28.2729 19.052 24.7629C24.816 23.0786 28.996 18.3214 28.996 12.7029C28.996 11.88 28.8933 11.0829 28.732 10.3114C28.813 10.3073 28.894 10.3017 28.9755 10.2961C29.1449 10.2846 29.3164 10.2729 29.4947 10.2729C35.8747 10.2729 41.0667 14.8243 41.0667 20.4171V32.4386Z"
        stroke={props.colour || "#FFFBF9"}
      />
    </S.Svg>
  );
}

export function Caudalie(props) {
  return (
    <S.Svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 99.6 22.81"
      {...props}
    >
      <g id="Layer_2-2">
        <path d="m44.75,6.62c-.09-.28-.18-.57-.27-.85.09-.02.18-.06.27-.06,1.91,0,3.82,0,5.73,0,.16,0,.32,0,.48-.01,2.43.19,4.34,1.31,5.76,3.28.36.5.63,1.03.87,1.6.26.61.45,1.24.55,1.89.08.55.08,1.11.11,1.66,0,.02,0,.05,0,.07-.04.67-.1,1.34-.3,1.99-.19.6-.38,1.19-.65,1.76-.39.8-.87,1.52-1.47,2.16-.86.92-1.88,1.58-3.08,1.97-.59.19-1.2.33-1.83.34-.14,0-.28,0-.43,0-2,0-4,0-6,0,.02-.08.04-.17.06-.25.19-.54.28-1.1.25-1.67,0-.02,0-.04,0-.06,0-.12,0-.23,0-.35,0-3.88,0-7.75,0-11.63,0-.54-.01-1.08-.02-1.63,0-.07-.02-.15-.03-.22Zm4.96.48c-.87,0-1.74,0-2.61,0,0,.02-.02.04-.03.06,0,.04,0,.07,0,.11,0,4.55,0,9.09,0,13.64.01.02.02.04.03.06,1.04,0,2.08,0,3.12.01.44,0,.88-.04,1.31-.13.86-.17,1.63-.54,2.28-1.13.94-.84,1.47-1.9,1.76-3.1.09-.35.11-.72.17-1.07.1-.57.06-1.15.02-1.73,0-.07-.02-.15-.02-.22-.02-.08-.05-.15-.05-.23-.03-.51-.13-1-.29-1.48-.17-.54-.38-1.08-.66-1.58-1.03-1.79-2.53-2.89-4.6-3.17-.14-.02-.29-.03-.43-.05Z" />
        <path d="m32.01,7.26c0,.13,0,.27,0,.4,0,2.86,0,5.72,0,8.58,0,.13,0,.27.01.4,0,.02-.01.04-.02.06.05.3.09.6.16.9.28,1.18.92,2.11,1.97,2.74.45.27.93.44,1.45.52.39.06.76.05,1.15,0,.38-.04.75-.1,1.11-.23,1.2-.45,2.06-1.27,2.54-2.46.14-.34.22-.71.28-1.08.08-.44.08-.88.08-1.32,0-2.69,0-5.39,0-8.08,0-.17-.01-.34-.02-.5,0-.02,0-.05,0-.07-.04-.42-.08-.84-.27-1.23-.03-.06-.04-.13-.06-.2.69,0,1.37,0,2.06,0-.08.26-.19.52-.22.8-.01.1-.03.21-.04.31,0,.06-.02.11-.03.17,0,.22-.02.44-.02.67,0,2.81,0,5.62,0,8.43,0,.12,0,.23-.01.35,0,0-.02.01-.02.01,0,.01.01.03.02.04,0,.05,0,.1,0,.15,0,.02,0,.05,0,.07,0,.03,0,.06,0,.09,0,.02-.01.05-.02.07-.15,1.64-.76,3.06-1.94,4.22-.7.68-1.51,1.18-2.45,1.44-.54.15-1.08.26-1.65.27-.64,0-1.28-.04-1.88-.24-1.54-.5-2.76-1.44-3.56-2.86-.26-.46-.48-.94-.63-1.44-.15-.5-.26-1.02-.26-1.55,0-.02,0-.05-.01-.07,0-.03,0-.06,0-.09,0-.04,0-.08,0-.12,0-2.89,0-5.78,0-8.67,0-.06,0-.12,0-.19,0-.04,0-.07,0-.11-.02-.3-.02-.6-.07-.89-.04-.26-.14-.51-.21-.76.02-.15.14-.11.23-.11.89,0,1.77,0,2.66,0,0,0,0,0,0,0,0,.02,0,.04,0,.05-.13.4-.29.79-.27,1.22,0,.09-.02.19-.02.28Z" />
        <path d="m61.79,16.29c-.41,1.03-.82,2.06-1.24,3.08-.26.64-.53,1.27-.79,1.91-.15.38-.29.76-.44,1.14-.68,0-1.37,0-2.05,0-.06,0-.13-.03-.19-.05.14-.18.27-.37.42-.55.59-.7.99-1.51,1.34-2.35.52-1.26,1.05-2.52,1.58-3.79.21-.52.41-1.04.63-1.56.23-.55.46-1.11.7-1.66.46-1.08.92-2.15,1.38-3.23.42-.99.83-1.98,1.24-2.98.12-.28.24-.57.36-.86h.52s.05.1.07.15c.23.59.45,1.19.69,1.78.37.91.75,1.82,1.13,2.73.38.93.76,1.87,1.14,2.81.41,1.01.81,2.02,1.22,3.03.41,1.03.83,2.05,1.25,3.08.15.38.31.76.47,1.14.28.64.69,1.2,1.16,1.71.16.18.31.36.47.54-.09.02-.18.05-.27.05-.98,0-1.96,0-2.95,0-.32-.81-.63-1.62-.96-2.43-.28-.7-.57-1.39-.84-2.08-.2-.51-.4-1.03-.6-1.54,0-.02,0-.05-.01-.08-.07-.11-.18-.06-.26-.06-.98,0-1.95,0-2.93,0-.67,0-1.33,0-2,0-.08,0-.16.04-.24.06Zm.55-1.36h4.34c-.25-.64-.49-1.26-.73-1.87-.46-1.17-.92-2.34-1.41-3.57-.74,1.85-1.46,3.64-2.19,5.44Z" />
        <path d="m26.64,22.42c-.18-.45-.36-.89-.54-1.34-.26-.65-.53-1.29-.79-1.94-.28-.71-.54-1.43-.81-2.14-.09-.23-.18-.47-.27-.7-.07-.11-.18-.06-.26-.06-.98,0-1.95,0-2.93,0-.67,0-1.33,0-2,0-.08,0-.16.04-.24.06-.32.79-.63,1.58-.95,2.36-.21.52-.45,1.04-.66,1.57-.28.71-.55,1.42-.82,2.12,0,.02-.03.05-.04.07-.69,0-1.39,0-2.08,0-.06,0-.11-.03-.17-.05.2-.26.4-.52.6-.78.52-.66.87-1.4,1.17-2.17.2-.5.42-.98.63-1.48.3-.72.58-1.44.87-2.16.28-.68.58-1.35.87-2.02.22-.52.41-1.04.63-1.56.27-.64.56-1.28.83-1.92.43-1.02.86-2.05,1.29-3.08.25-.6.49-1.2.74-1.8h.53c.17.41.35.83.51,1.25.27.67.52,1.34.79,2.01.3.74.61,1.47.92,2.21.38.93.76,1.87,1.14,2.81.37.92.74,1.84,1.11,2.76.42,1.04.84,2.07,1.25,3.11.31.78.69,1.51,1.28,2.12.21.22.4.47.61.71-.07.02-.15.05-.22.05-1,0-1.99,0-2.99,0Zm-2.96-7.48c-.71-1.81-1.42-3.6-2.15-5.44-.75,1.84-1.47,3.64-2.2,5.44h4.35Z" />
        <path d="m9.19,5.38c1.46.11,2.84.48,4.1,1.25.04.02.07.05.11.07.22.1.32.26.31.5,0,.02,0,.05,0,.07,0,.03,0,.06,0,.1,0,0-.01.01-.01.02,0,.01.01.03.02.04,0,.19.02.38.03.56,0,.1.01.19.02.29.01.19.02.38.03.56,0,.1.01.19.02.29.01.19.02.38.03.56,0,.1.01.19.02.29.01.18.03.36.04.54-.03,0-.06,0-.08,0-.37-.66-.77-1.3-1.3-1.84-.79-.8-1.7-1.42-2.81-1.7-.56-.14-1.12-.2-1.7-.1-.26.04-.52.05-.78.1-.57.11-1.1.32-1.6.6-1.27.72-2.07,1.82-2.53,3.18-.16.48-.27.98-.38,1.47-.04.15-.01.32-.01.48,0,.11-.02.22-.02.34,0,.19,0,.37,0,.56,0,.02,0,.05,0,.07,0,.07,0,.13,0,.2,0,.04,0,.08,0,.12,0,.68.14,1.35.3,2,.36,1.41,1.01,2.65,2.07,3.67.52.5,1.11.88,1.77,1.17.54.23,1.1.37,1.68.38.12.06.25.06.37,0,.63-.03,1.25-.11,1.85-.3.88-.28,1.59-.81,2.19-1.5.28-.33.55-.67.83-1.01.07-.09.15-.17.27-.23-.05.27-.09.54-.14.81-.05.26-.09.51-.14.77-.06.33-.17.65-.19.98-.02.27-.18.38-.36.5-.75.51-1.55.91-2.42,1.15-.34.09-.7.14-1.05.21-.1.02-.2.03-.31.05-.53,0-1.07,0-1.6,0-.56,0-1.09-.13-1.62-.28-2.09-.59-3.77-1.77-4.96-3.6-.35-.54-.64-1.11-.83-1.73-.11-.35-.23-.7-.31-1.06-.06-.28-.06-.56-.08-.85,0-.09-.02-.19-.03-.28C0,14.52,0,14.2,0,13.88c0-.07,0-.15.01-.22.03-.24.06-.49.09-.73.06-.36.13-.71.24-1.06.16-.57.38-1.11.66-1.64,1.13-2.16,2.83-3.68,5.16-4.47.45-.15.9-.28,1.37-.32.23-.02.45-.04.68-.06.33,0,.65,0,.98,0Z" />
        <path d="m92.27,13.5c0,.11-.02.21-.02.32,0,2.37,0,4.73,0,7.1,0,.02.02.04.03.05,1.63,0,3.25,0,4.88,0,.38,0,.75-.08,1.1-.19.44-.13.87-.28,1.34-.43-.17.69-.35,1.38-.55,2.06-3.12,0-6.24,0-9.36,0-.06,0-.12,0-.19,0,.06-.2.11-.4.18-.59.09-.26.15-.51.13-.79,0-.02.02-.04.03-.06,0-.28.02-.55.02-.82,0-4.02,0-8.03,0-12.05,0-.29,0-.59-.01-.88,0-.06-.02-.12-.02-.18,0-.03,0-.07,0-.1,0,0,.02-.01.01-.02,0-.01-.01-.03-.02-.04,0-.02,0-.04,0-.05-.01-.02-.02-.04-.04-.05-.05-.28-.06-.56-.21-.81-.04-.07-.04-.16-.06-.25.07,0,.14,0,.21,0,2.83,0,5.66,0,8.49,0,.08,0,.16,0,.24,0,.13.66.27,1.33.41,2.04-.67-.27-1.31-.52-1.99-.6-.1-.02-.21-.04-.31-.04-1.39,0-2.78,0-4.17,0-.04,0-.08.03-.12.05,0,.1-.01.19-.01.29,0,1.54,0,3.07,0,4.61,0,.02.02.04.03.06,1.27,0,2.54,0,3.81,0,.67,0,1.35,0,2.06,0-.17.46-.33.89-.49,1.33-.12,0-.23,0-.35,0-1.58,0-3.16,0-4.73,0-.1,0-.2.03-.3.05Z" />
        <path d="m73.87,20.87c0-4.22,0-8.44.01-12.66,0-.22,0-.44-.01-.67,0-.04,0-.08,0-.13-.03-.41-.04-.82-.17-1.21-.05-.16-.11-.33-.16-.49,1.01,0,2.03,0,3.04,0-.01.06-.01.12-.03.18-.16.39-.21.79-.24,1.2,0,.08,0,.15-.01.23,0,.33-.02.66-.02.99,0,4.15,0,8.3,0,12.45,0,.05,0,.11,0,.16.01.02.03.03.04.05.8,0,1.6,0,2.4,0,.3,0,.6,0,.91,0,.87.03,1.71-.14,2.52-.47.15-.06.3-.11.49-.18-.19.71-.35,1.41-.55,2.09-2.85,0-5.69,0-8.54,0,.05-.17.08-.34.15-.49.13-.32.18-.65.18-.99,0-.02,0-.04,0-.06Z" />
        <path d="m86.45,21.09c-.02.45.16.85.3,1.27-.06.02-.13.06-.19.06-.96,0-1.91,0-2.87,0,.07-.22.12-.44.21-.65.14-.33.15-.67.15-1.02,0-.8,0-1.6,0-2.4,0-3.62,0-7.25,0-10.87,0-.19-.02-.39-.03-.58,0-.06-.02-.11-.02-.17-.06-.23-.13-.45-.19-.68-.03-.11-.08-.22-.12-.33,1.03,0,2.05,0,3.08,0-.09.29-.19.59-.28.88-.03.11-.02.22-.04.34,0,.07-.02.15-.03.22,0,.31-.02.62-.02.93,0,4.07,0,8.14,0,12.21,0,.24.02.48.03.72,0,.02,0,.04.01.07Z" />
        <path d="m84.36,2.9c-.13-.02-.27-.03-.39-.07-.31-.1-.43-.31-.35-.62.05-.18.15-.36.25-.52.24-.35.56-.62.91-.86.59-.41,1.22-.71,1.93-.83.24-.04.51,0,.76.06.28.06.4.37.3.7-.09.28-.26.5-.46.71-.52.54-1.15.92-1.84,1.19-.35.14-.72.22-1.1.24Z" />
        <path d="m89.51,22.41c.06,0,.12,0,.19,0,3.12,0,6.24,0,9.36,0-.07.02-.14.05-.21.05-.46,0-.93,0-1.39,0-2.55,0-5.11,0-7.66,0-.09,0-.21.06-.29-.06Z" />
        <path d="m98.45,5.72c-.08,0-.16,0-.24,0-2.83,0-5.66,0-8.49,0-.07,0-.14,0-.21,0,.02-.02.05-.05.07-.05.07,0,.14,0,.21,0,2.79,0,5.58,0,8.37,0,.1,0,.21-.06.29.06Z" />
        <path d="m73.53,22.42c2.85,0,5.69,0,8.54,0-.07.02-.14.05-.21.05-.4,0-.8,0-1.2,0-2.29,0-4.57,0-6.86,0-.09,0-.18-.03-.26-.05Z" />
        <path d="m50.95,5.7c-.16,0-.32,0-.48.01-1.91,0-3.82,0-5.73,0-.09,0-.18.04-.27.06,0-.03,0-.1.01-.1.06-.01.12-.01.19-.01,1.97,0,3.93,0,5.9,0,.13,0,.26.03.39.04Z" />
        <path d="m44.47,22.42c2,0,4,0,6,0,.14,0,.28,0,.43,0-.12.02-.24.05-.37.05-1.96,0-3.92,0-5.89,0-.06,0-.11-.03-.17-.05Z" />
        <path d="m61.79,16.29c.08-.02.16-.06.24-.06.67,0,1.33,0,2,0,.98,0,1.95,0,2.93,0,.09,0,.2-.05.26.06-.07,0-.14-.01-.21-.01-1.67,0-3.33,0-5,0-.07,0-.14,0-.21.01Z" />
        <path d="m18.8,16.29c.08-.02.16-.06.24-.06.67,0,1.33,0,2,0,.98,0,1.95,0,2.93,0,.09,0,.2-.05.26.06-.07,0-.14-.01-.21-.01-1.67,0-3.33,0-5,0-.07,0-.14,0-.21.01Z" />
        <path d="m92.27,13.5c.1-.02.2-.05.3-.05,1.58,0,3.16,0,4.73,0,.12,0,.23,0,.35,0-.09.02-.18.06-.26.06-1.55,0-3.09,0-4.64,0-.16,0-.32,0-.48,0Z" />
        <path d="m92.27,7.15s.08-.05.12-.05c1.39,0,2.78,0,4.17,0,.1,0,.21.03.31.04-.35,0-.71,0-1.06,0-1.18,0-2.36,0-3.54,0Z" />
        <path d="m69.62,22.43c.98,0,1.96,0,2.95,0,.09,0,.18-.03.27-.05,0,.03,0,.07.01.1-.05,0-.11,0-.16,0-.96,0-1.92,0-2.87,0-.07,0-.13-.03-.2-.04Z" />
        <path d="m26.64,22.42c1,0,1.99,0,2.99,0,.07,0,.15-.03.22-.05,0,.03.02.05.03.08-.05,0-.1.02-.15.02-.97,0-1.95,0-2.92,0-.05,0-.11-.03-.16-.05Z" />
        <path d="m83.69,22.41c.96,0,1.91,0,2.87,0,.06,0,.13-.04.19-.06,0,.04,0,.1-.01.1-.06.01-.12.01-.18.01-.88,0-1.77,0-2.65,0-.07,0-.14-.04-.2-.06Z" />
        <path d="m86.76,5.72c-1.03,0-2.05,0-3.08,0,.03-.02.07-.05.1-.05.96,0,1.92,0,2.88,0,.03,0,.07.04.1.06Z" />
        <path d="m76.57,5.71c-1.01,0-2.03,0-3.04,0,.03-.02.07-.05.1-.05.95,0,1.89,0,2.84,0,.03,0,.07.03.1.05Z" />
        <path d="m32.31,5.71c-.89,0-1.77,0-2.66,0-.09,0-.21-.05-.23.11-.02-.04-.03-.09-.05-.15.09,0,.15-.01.21-.01.84,0,1.68,0,2.52,0,.07,0,.14.03.21.05Z" />
        <path d="m57.07,22.36c.06.02.13.05.19.05.68,0,1.37,0,2.05,0-.04.02-.09.05-.13.05-.67,0-1.34,0-2.01,0-.11,0-.11,0-.1-.11Z" />
        <path d="m14.09,22.37c.06.02.11.05.17.05.69,0,1.39,0,2.08,0-.04.02-.09.06-.13.06-.67,0-1.34,0-2.01,0-.04,0-.08-.02-.12-.02,0-.03.02-.05.02-.08Z" />
        <path d="m42.44,5.72c-.69,0-1.37,0-2.06,0,.02-.02.05-.05.07-.05.64,0,1.28,0,1.92,0,.02,0,.05.03.07.05Z" />
        <path d="m7.85,22.63c.53,0,1.07,0,1.6,0-.53.09-1.07.09-1.6,0Z" />
        <path d="m9.19,5.38c-.33,0-.65,0-.98,0,.33-.07.65-.07.98,0Z" />
        <path d="m8.92,21.21c-.12.06-.25.06-.37,0,.12,0,.25,0,.37,0Z" />
        <path d="m2.69,13.04c0-.11.02-.22.02-.34,0,.11-.02.22-.02.34Z" />
        <path d="m0,14.84c0,.09.02.19.03.28,0-.09-.02-.19-.03-.28Z" />
        <path d="m13.82,9.13c0-.1-.01-.19-.02-.29,0,.1.01.19.02.29Z" />
        <path d="m13.87,9.98c0-.1-.01-.19-.02-.29,0,.1.01.19.02.29Z" />
        <path d="m32.01,7.26c0-.09.02-.19.02-.28,0,.09-.02.19-.02.28Z" />
        <path d="m13.77,8.28c0-.1-.01-.19-.02-.29,0,.1.01.19.02.29Z" />
        <path d="m13.83,10.52s.06,0,.08,0c0,.03,0,.05-.01.08-.02-.03-.05-.05-.07-.08Z" />
        <path d="m.01,13.66c0,.07,0,.15-.01.22,0-.07,0-.15.01-.22Z" />
        <path d="m44.75,6.62c0,.07.02.15.03.22,0-.07-.02-.15-.03-.22Z" />
        <path d="m76.29,7.32c0-.08,0-.15.01-.23,0,.08,0,.15-.01.23Z" />
        <path d="m86.42,7.16c0-.07.02-.15.03-.22,0,.07-.02.15-.03.22Z" />
        <path d="m89.83,7.04c0,.06.02.12.02.18,0-.06-.02-.12-.02-.18Z" />
        <path d="m84,6.72c0,.06.02.11.02.17,0-.06-.02-.11-.02-.17Z" />
        <path d="m42.15,7c0-.06.02-.11.03-.17,0,.06-.02.11-.03.17Z" />
        <path d="m2.71,13.99s0-.08,0-.12c0,.04,0,.08,0,.12Z" />
        <path d="m29.7,7.47s0,.07,0,.11c0-.04,0-.07,0-.11Z" />
        <path d="m29.69,16.43s0,.08,0,.12c0-.04,0-.08,0-.12Z" />
        <path d="m73.86,7.41s0,.08,0,.13c0-.04,0-.08,0-.13Z" />
        <path d="m44.78,20.44s0,.04,0,.06c0-.02,0-.04,0-.06Z" />
        <path d="m42.09,16.88s.01-.05.02-.07c0,.02-.01.05-.02.07Z" />
        <path d="m92.28,12.11s-.02-.04-.03-.06c0,.02.02.04.03.06Z" />
        <path d="m13.72,7.42s-.01-.03-.02-.04c0,0,0-.01.01-.02,0,.02,0,.04,0,.06Z" />
        <path d="m31.99,16.71s.01-.04.02-.06c0,.02-.01.04-.02.06Z" />
        <path d="m73.87,20.87s0,.04,0,.06c0-.02,0-.04,0-.06Z" />
        <path d="m76.31,20.97s-.03-.03-.04-.05c.01.02.03.03.04.05Z" />
        <path d="m92.28,20.97s-.02-.04-.03-.05c0,.02.02.04.03.05Z" />
        <path d="m89.84,20.98s-.02.04-.03.06c0-.02.02-.04.03-.06Z" />
        <path d="m86.45,21.09s0-.04-.01-.07c0,.01.02.03.02.04,0,0,0,.01-.01.02Z" />
        <path d="m29.71,16.64s0,.05.01.07c0-.02,0-.05-.01-.07Z" />
        <path d="m42.12,16.49s-.01-.03-.02-.04c0,0,.01,0,.02-.01,0,.02,0,.04,0,.05Z" />
        <path d="m89.82,6.88s.01.03.02.04c0,0,0,.01-.01.02,0-.02,0-.04,0-.06Z" />
        <path d="m13.71,7.26s0-.05,0-.07c0,.02,0,.05,0,.07Z" />
        <path d="m89.78,6.77s.02.04.04.05c-.01-.02-.02-.04-.04-.05Z" />
        <path d="m40.7,7.14s0,.05,0,.07c0-.02,0-.05,0-.07Z" />
        <path d="m2.7,13.67s0-.05,0-.07c0,.02,0,.05,0,.07Z" />
        <path d="m32.3,5.76s0-.04,0-.05c0,.01.01.02.02.04,0,0-.01.01-.02.02Z" />
        <path d="m58.23,14.21s0-.05,0-.07c0,.02,0,.05,0,.07Z" />
        <path d="m42.12,16.72s0-.05,0-.07c0,.02,0,.05,0,.07Z" />
        <path d="m49.73,7.13c-.09,0-.18.02-.26.02-.79,0-1.58,0-2.37,0,0-.02,0-.03,0-.05.87,0,1.74,0,2.61,0,0,.01.02.02.02.03Z" />
        <path d="m49.73,7.13s-.02-.02-.02-.03c.14.02.29.03.43.05-.14,0-.27,0-.41-.01Z" />
        <path d="m55.77,13.83c0-.07-.02-.15-.02-.22,0,.07.02.15.02.22Z" />
        <path d="m47.1,7.11s0,.03,0,.05c0,0-.01.01-.01.01,0,0-.02,0-.02,0,0-.02.02-.04.03-.06Z" />
        <path d="m47.07,20.91s.02.04.03.06c-.01-.02-.02-.04-.03-.06Z" />
      </g>
    </S.Svg>
  );
}

export function TinyClock(props) {
  return (
    <S.Svg viewBox="0 0 14 14" width="14" height="14" fill="none" {...props}>
      <circle cx="7.11819" cy="6.93606" r="6.42727" fill="#414143" />
      <line
        x1="7.61816"
        y1="3.26367"
        x2="7.61816"
        y2="7.85458"
        stroke="#FFFBF9"
      />
      <line
        x1="3.44543"
        y1="7.35449"
        x2="8.03634"
        y2="7.35449"
        stroke="#FFFBF9"
      />
    </S.Svg>
  );
}

export function Clock(props) {
  return (
    <S.Svg viewBox="0 0 16 15" width="16" height="15" {...props}>
      <path
        fill="currentColor"
        d="M9.75 7.713H8.244V5.359a.5.5 0 0 0-.5-.5H7.65a.5.5 0 0 0-.5.5v2.947a.5.5 0 0 0 .5.5h.094l.003-.001.003.002h2a.5.5 0 0 0 .5-.5v-.094a.5.5 0 0 0-.5-.5zm0-5.263h-3.5c-1.82 0-3.3 1.48-3.3 3.3v3.5c0 1.82 1.48 3.3 3.3 3.3h3.5c1.82 0 3.3-1.48 3.3-3.3v-3.5c0-1.82-1.48-3.3-3.3-3.3zm2 6.8a2 2 0 0 1-2 2h-3.5a2 2 0 0 1-2-2v-3.5a2 2 0 0 1 2-2h3.5a2 2 0 0 1 2 2v3.5z"
      />
    </S.Svg>
  );
}

export function Coffee(props) {
  return (
    <S.Svg width="50" height="50" viewBox="0 0 511.988 511.988" {...props}>
      <path d="M394.655,202.654H95.988c-17.643,0-32,14.357-32,32v21.333c0,76.117,42.048,145.152,109.717,180.16c5.227,2.688,11.669,0.661,14.379-4.587c2.688-5.227,0.661-11.669-4.587-14.379c-60.544-31.317-98.176-93.077-98.176-161.195v-21.333c0-5.888,4.779-10.667,10.667-10.667h298.667c5.888,0,10.667,4.779,10.667,10.667v21.333c0,68.117-37.632,129.877-98.197,161.173c-5.248,2.709-7.275,9.152-4.587,14.379c1.899,3.669,5.632,5.781,9.493,5.781c1.664,0,3.328-0.384,4.885-1.195c67.691-34.987,109.739-104,109.739-180.139v-21.333C426.655,217.011,412.297,202.654,394.655,202.654z" />
      <path d="M489.865,422.558c-1.664-3.989-5.547-6.592-9.856-6.592H10.676c-4.309,0-8.192,2.603-9.856,6.592c-1.664,3.989-0.747,8.576,2.304,11.627l23.915,23.936c14.123,14.101,32.853,21.867,52.8,21.867h330.965c19.947,0,38.699-7.765,52.843-21.867l23.915-23.936C490.612,431.134,491.529,426.547,489.865,422.558z M448.543,443.038c-10.069,10.069-23.488,15.616-37.717,15.616H79.839c-14.229,0-27.648-5.547-37.717-15.616l-5.717-5.717H454.26L448.543,443.038z" />
      <path d="M491.359,253.022c-28.736-18.475-74.645,1.579-79.787,3.904c-5.355,2.453-7.744,8.768-5.291,14.144c2.453,5.376,8.747,7.744,14.144,5.291c10.283-4.672,43.264-15.744,59.392-5.355c7.275,4.672,10.837,13.739,10.837,27.648c0,42.709-86.144,68.523-119.403,74.88l-7.552,1.493c-5.781,1.131-9.536,6.741-8.405,12.523c1.003,5.077,5.461,8.597,10.453,8.597c0.683,0,1.365-0.064,2.069-0.213l7.488-1.472c5.589-1.067,136.683-26.773,136.683-95.808C511.988,277.193,505.034,261.854,491.359,253.022z" />
      <path d="M328.372,113.31c17.344-21.675,17.344-55.616,0-77.291c-3.691-4.608-10.368-5.376-14.997-1.664c-4.608,3.691-5.355,10.389-1.664,14.997c10.987,13.717,10.987,36.907-0.021,50.667c-17.365,21.675-17.365,55.616,0,77.291c2.112,2.645,5.205,4.011,8.341,4.011c2.325,0,4.693-0.768,6.656-2.347c4.608-3.691,5.355-10.411,1.664-14.997C317.343,150.259,317.343,127.07,328.372,113.31z" />
      <path d="M264.287,113.31c17.365-21.675,17.365-55.616,0-77.291c-3.669-4.608-10.389-5.355-14.997-1.664c-4.608,3.691-5.355,10.411-1.664,14.997c11.008,13.717,11.008,36.907-0.021,50.667c-17.344,21.675-17.344,55.616,0,77.291c2.112,2.645,5.205,4.011,8.341,4.011c2.325,0,4.672-0.768,6.656-2.347c4.608-3.691,5.355-10.389,1.664-14.997C253.279,150.259,253.279,127.07,264.287,113.31z" />
      <path d="M200.372,113.331c17.344-21.675,17.344-55.616,0-77.291c-3.669-4.608-10.368-5.376-14.997-1.664c-4.587,3.669-5.333,10.389-1.664,14.976c10.987,13.717,10.987,36.907-0.021,50.667c-17.365,21.675-17.365,55.616,0,77.291c2.112,2.645,5.205,4.011,8.341,4.011c2.325,0,4.693-0.768,6.656-2.325c4.608-3.691,5.355-10.411,1.664-14.997C189.343,150.259,189.343,127.091,200.372,113.331z" />
    </S.Svg>
  );
}

export function Comment(props) {
  const currSize = props.size || 18;

  return (
    <S.Svg
      width={currSize}
      height={currSize}
      viewBox="0 0 18 18"
      stroke={u.colours.charcoal}
      {...props}
    >
      <path
        d="M1.5075 3C1.5075 2.175 2.175 1.5 3 1.5H15C15.825 1.5 16.5 2.175 16.5 3V12C16.5 12.825 15.825 13.5 15 13.5H4.5L1.5 16.5L1.5075 3Z"
        fill="transparent"
      />
    </S.Svg>
  );
}

export function Connect(props) {
  const currSize = props.size || 18;

  return (
    <S.Svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      color={u.colours.charcoal}
      width={currSize}
      height={currSize}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1a1 1 0 001 1h14a1 1 0 001-1v-1c0-2.66-5.33-4-8-4zm-9 0a1 1 0 11-2 0v-2H2a1 1 0 110-2h2V8a1 1 0 012 0v2h2a1 1 0 110 2H6v2z"
        fill="currentColor"
      />
    </S.Svg>
  );
}

export function Cross(props) {
  return (
    <S.Svg
      width={props.width || "13"}
      height={props.height || "13"}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="16.4204"
        height="1.96277"
        rx="0.981383"
        transform="matrix(0.707046 0.707168 -0.707046 0.707168 1.39062 0)"
        fill={props.color || u.colours.charcoal}
      />
      <rect
        width="16.4204"
        height="1.96277"
        rx="0.981383"
        transform="matrix(-0.707046 0.707168 0.707046 0.707168 11.6094 0)"
        fill={props.color || u.colours.charcoal}
      />
    </S.Svg>
  );
}

export function Download(props) {
  return (
    <S.Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18ZM10.55 10H13.45V13H16L12 17L8 13H10.55V10Z"
        fill="white"
      />
    </S.Svg>
  );
}

export function Dropdown(props) {
  return (
    <S.Svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 12H11V10H7V12ZM0 0V2H18V0H0ZM3 7H15V5H3V7Z"
        fill={props.colour || "white"}
      />
    </S.Svg>
  );
}

export function Embed(props) {
  return (
    <S.Svg
      viewBox="0 0 24 24"
      color="rgb(224, 36, 94)"
      width="20"
      height="20"
      {...props}
    >
      <g>
        <path d="M23.804 11.5l-6.496-7.25c-.278-.31-.752-.334-1.06-.06-.308.277-.334.752-.058 1.06L22.238 12l-6.047 6.75c-.275.308-.25.782.06 1.06.142.127.32.19.5.19.204 0 .41-.084.558-.25l6.496-7.25c.252-.28.258-.713 0-1zm-23.606 0l6.496-7.25c.278-.31.752-.334 1.06-.06.308.277.334.752.058 1.06L1.764 12l6.047 6.75c.277.308.25.782-.057 1.06-.143.127-.322.19-.5.19-.206 0-.41-.084-.56-.25L.197 12.5c-.252-.28-.257-.713 0-1zm9.872 12c-.045 0-.09-.004-.135-.012-.407-.073-.68-.463-.605-.87l3.863-21.5c.074-.407.466-.674.87-.606.408.073.68.463.606.87l-3.864 21.5c-.065.363-.38.618-.737.618z" />
      </g>
    </S.Svg>
  );
}

export function Event(props) {
  return (
    <S.Svg
      viewBox="0 0 24 24"
      color="rgba(6, 189, 182, 1)"
      width="40"
      height="40"
      {...props}
    >
      <path
        d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
        fill="currentColor"
      />
    </S.Svg>
  );
}

export function Facebook(props) {
  return (
    <S.Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.3103 0.367188H1.06995C0.478855 0.367188 0 0.846042 0 1.43714V18.6783C0 19.2686 0.478855 19.7475 1.06995 19.7475H10.3523V12.2425H7.8264V9.31765H10.3523V7.16078C10.3523 4.6575 11.8809 3.29442 14.1145 3.29442C15.1845 3.29442 16.1034 3.37436 16.3715 3.40989V6.02623L14.8227 6.02704C13.6082 6.02704 13.3732 6.60441 13.3732 7.45068V9.31846H16.2697L15.8926 12.2433H13.3732V19.7475H18.3119C18.9014 19.7475 19.3803 19.2686 19.3803 18.6775V1.43714C19.3803 0.846042 18.9014 0.367188 18.3103 0.367188V0.367188Z"
        fill={props.colour ? props.colour : u.colours.charcoal}
      />
    </S.Svg>
  );
}

export function FreeBanner(props) {
  return (
    <S.Svg
      width="46"
      height="20"
      viewBox="0 0 46 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0H46L41 10L46 20H0V0Z" fill="#D68B76" />
      <path
        d="M8.286 14V10.358H11.868V9.068H8.286V6.926H12.402V5.636H6.84V14H8.286ZM18.3911 10.304C19.3811 9.98 19.9271 9.224 19.9271 8.042C19.9271 6.572 19.0931 5.636 17.0831 5.636H14.3831V14H15.8291V10.496H16.4171C16.5311 10.496 16.6811 10.496 16.8491 10.49L18.9191 14H20.6051L18.3911 10.304ZM15.8291 6.926H16.9391C17.7911 6.926 18.4871 7.148 18.4871 8.06C18.4871 8.978 17.8031 9.224 16.9391 9.224H15.8291V6.926ZM28.1033 14V12.71H23.9933V10.358H27.8033V9.068H23.9933V6.926H28.1033V5.636H22.5473V14H28.1033ZM35.8926 14V12.71H31.7826V10.358H35.5926V9.068H31.7826V6.926H35.8926V5.636H30.3366V14H35.8926Z"
        fill="white"
      />
    </S.Svg>
  );
}

export function Group(props) {
  return (
    <S.Svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 212 212"
      width="50"
      height="50"
      {...props}
    >
      <path
        fill={props.colour || "currentColor"}
        d="M61.543 100.988c8.073 0 14.246-6.174 14.246-14.246s-6.173-14.246-14.246-14.246-14.246 6.173-14.246 14.246 6.174 14.246 14.246 14.246zm8.159 17.541a48.192 48.192 0 0 1 8.545-6.062c-4.174-2.217-9.641-3.859-16.704-3.859-21.844 0-28.492 15.67-28.492 15.67v8.073h26.181l.105-.248c.303-.713 3.164-7.151 10.365-13.574zm80.755-9.921c-6.854 0-12.21 1.543-16.336 3.661a48.223 48.223 0 0 1 8.903 6.26c7.201 6.422 10.061 12.861 10.364 13.574l.105.248h25.456v-8.073c-.001 0-6.649-15.67-28.492-15.67zm0-7.62c8.073 0 14.246-6.174 14.246-14.246s-6.173-14.246-14.246-14.246-14.246 6.173-14.246 14.246 6.173 14.246 14.246 14.246zm-44.093 3.21a23.21 23.21 0 0 0 4.464-.428c.717-.14 1.419-.315 2.106-.521 1.03-.309 2.023-.69 2.976-1.138a21.099 21.099 0 0 0 3.574-2.133 20.872 20.872 0 0 0 5.515-6.091 21.283 21.283 0 0 0 2.121-4.823 22.16 22.16 0 0 0 .706-3.193c.16-1.097.242-2.224.242-3.377s-.083-2.281-.242-3.377a22.778 22.778 0 0 0-.706-3.193 21.283 21.283 0 0 0-3.272-6.55 20.848 20.848 0 0 0-4.364-4.364 21.099 21.099 0 0 0-3.574-2.133 21.488 21.488 0 0 0-2.976-1.138 22.33 22.33 0 0 0-2.106-.521 23.202 23.202 0 0 0-4.464-.428c-12.299 0-21.705 9.405-21.705 21.704 0 12.299 9.406 21.704 21.705 21.704zM145.629 131a36.739 36.739 0 0 0-1.2-1.718 39.804 39.804 0 0 0-3.367-3.967 41.481 41.481 0 0 0-3.442-3.179 42.078 42.078 0 0 0-5.931-4.083 43.725 43.725 0 0 0-3.476-1.776c-.036-.016-.069-.034-.104-.05-5.692-2.581-12.849-4.376-21.746-4.376-8.898 0-16.055 1.795-21.746 4.376-.196.089-.379.185-.572.276a43.316 43.316 0 0 0-3.62 1.917 42.32 42.32 0 0 0-5.318 3.716 41.501 41.501 0 0 0-3.443 3.179 40.632 40.632 0 0 0-3.366 3.967c-.452.61-.851 1.186-1.2 1.718-.324.493-.6.943-.841 1.351l-.061.101a27.96 27.96 0 0 0-.622 1.119c-.325.621-.475.975-.475.975v11.692h82.53v-11.692s-.36-.842-1.158-2.195a35.417 35.417 0 0 0-.842-1.351z"
      ></path>
    </S.Svg>
  );
}

export function Heart(props) {
  return (
    <S.Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={u.colours.charcoal}
        d="M10 2.9152C11.09 1.6352 12.76 0.825195 14.5 0.825195C17.58 0.825195 20 3.2452 20 6.3252C20 10.1021 16.6056 13.1801 11.4627 17.8437L11.45 17.8552L10 19.1752L8.55 17.8652L8.51052 17.8293C3.38263 13.1694 0 10.0955 0 6.3252C0 3.2452 2.42 0.825195 5.5 0.825195C7.24 0.825195 8.91 1.6352 10 2.9152ZM10 16.4752L10.1 16.3752C14.86 12.0652 18 9.2152 18 6.3252C18 4.3252 16.5 2.8252 14.5 2.8252C12.96 2.8252 11.46 3.8152 10.94 5.18519H9.07C8.54 3.8152 7.04 2.8252 5.5 2.8252C3.5 2.8252 2 4.3252 2 6.3252C2 9.2152 5.14 12.0652 9.9 16.3752L10 16.4752Z"
      />
    </S.Svg>
  );
}

export function HeartActive(props) {
  const currSize = props.size || 18;

  return (
    <S.Svg
      width={currSize}
      height={currSize}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M14.5 0.825195C12.76 0.825195 11.09 1.6352 10 2.9152C8.91 1.6352 7.24 0.825195 5.5 0.825195C2.42 0.825195 0 3.2452 0 6.3252C0 10.1052 3.4 13.1852 8.55 17.8652L10 19.1752L11.45 17.8552C16.6 13.1852 20 10.1052 20 6.3252C20 3.2452 17.58 0.825195 14.5 0.825195Z"
        fill={u.colours.errorRed}
      />
    </S.Svg>
  );
}

export function Hyperlink(props) {
  return (
    <S.Svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M0 0h48v48h-48z" fill="none" />
      <path d="M7.8 24c0-3.42 2.78-6.2 6.2-6.2h8v-3.8h-8c-5.52 0-10 4.48-10 10s4.48 10 10 10h8v-3.8h-8c-3.42 0-6.2-2.78-6.2-6.2zm8.2 2h16v-4h-16v4zm18-12h-8v3.8h8c3.42 0 6.2 2.78 6.2 6.2s-2.78 6.2-6.2 6.2h-8v3.8h8c5.52 0 10-4.48 10-10s-4.48-10-10-10z" />
    </S.Svg>
  );
}

export function Inbox(props) {
  return (
    <S.Svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color="rgba(65, 65, 67, 1)"
      width="18"
      height="18"
      {...props}
    >
      <path
        d="M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z"
        fill={u.colours.charcoal}
      />
    </S.Svg>
  );
}

export function Instagram(props) {
  return (
    <S.Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.69014 2.11384C12.2774 2.11384 12.5843 2.12353 13.6066 2.17036C16.2326 2.28987 17.4592 3.53586 17.5787 6.14251C17.6256 7.16401 17.6344 7.47087 17.6344 10.0581C17.6344 12.6462 17.6248 12.9523 17.5787 13.9738C17.4584 16.578 16.235 17.8264 13.6066 17.9459C12.5843 17.9927 12.279 18.0024 9.69014 18.0024C7.10287 18.0024 6.79602 17.9927 5.77452 17.9459C3.14203 17.8256 1.92188 16.5739 1.80237 13.973C1.75553 12.9515 1.74584 12.6454 1.74584 10.0573C1.74584 7.47006 1.75634 7.16401 1.80237 6.1417C1.92269 3.53586 3.14607 2.28907 5.77452 2.16955C6.79683 2.12353 7.10287 2.11384 9.69014 2.11384ZM9.69014 0.367188C7.05846 0.367188 6.729 0.378493 5.69538 0.425328C2.17624 0.586831 0.220451 2.53939 0.0589484 6.06176C0.0113052 7.09618 0 7.42565 0 10.0573C0 12.689 0.0113052 13.0193 0.0581408 14.0529C0.219643 17.572 2.17221 19.5278 5.69457 19.6893C6.729 19.7362 7.05846 19.7475 9.69014 19.7475C12.3218 19.7475 12.6521 19.7362 13.6857 19.6893C17.2016 19.5278 19.1623 17.5753 19.3213 14.0529C19.369 13.0193 19.3803 12.689 19.3803 10.0573C19.3803 7.42565 19.369 7.09618 19.3221 6.06257C19.1639 2.54666 17.2089 0.587638 13.6865 0.426136C12.6521 0.378493 12.3218 0.367188 9.69014 0.367188V0.367188ZM9.69014 5.08144C6.94218 5.08144 4.71425 7.30937 4.71425 10.0573C4.71425 12.8053 6.94218 15.034 9.69014 15.034C12.4381 15.034 14.666 12.8061 14.666 10.0573C14.666 7.30937 12.4381 5.08144 9.69014 5.08144ZM9.69014 13.2874C7.90635 13.2874 6.46009 11.8419 6.46009 10.0573C6.46009 8.27353 7.90635 6.82728 9.69014 6.82728C11.4739 6.82728 12.9202 8.27353 12.9202 10.0573C12.9202 11.8419 11.4739 13.2874 9.69014 13.2874ZM14.8631 3.7224C14.2203 3.7224 13.6994 4.24324 13.6994 4.88522C13.6994 5.52719 14.2203 6.04803 14.8631 6.04803C15.505 6.04803 16.0251 5.52719 16.0251 4.88522C16.0251 4.24324 15.505 3.7224 14.8631 3.7224Z"
        fill={props.colour ? props.colour : u.colours.charcoal}
      />
    </S.Svg>
  );
}

export function IWD(props) {
  return (
    <S.Svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 51.31 25.9"
      {...props}
    >
      <g id="Layer_2-2">
        <path d="m0,.13c1.04.13,1.92.4,1.92,1.31v14.81c0,.91-.88,1.19-1.92,1.31v.13h7.05v-.13c-1.04-.13-1.92-.4-1.92-1.31V1.44c0-.91.88-1.19,1.92-1.31v-.13H0v.13Z" />
        <path d="m41.4,0h-10.3l-.76.81c.77-.17,1.94-.38,4.14-.44.5.19.83.51.83,1.07v2.48l-9.07,12.1-.35-12.99c-.05-2.22,1.11-2.78,2.96-2.93l.03-.1h-8.52l-.76.81c.48-.1,1.11-.23,2.12-.3.99-.08.91.35.94,1.21l.2,5.61-6.5,8.7-.35-12.99c-.05-2.22,1.11-2.78,2.96-2.93l.03-.1h-8.52l-.76.81c.48-.1,1.11-.23,2.12-.3.99-.08.91.35.94,1.21l.61,16.33-.25.53,3.13-1.74,6.62-8.77.38,9.99-.25.53,3.13-1.74,9.17-12.18v11.1c0,.91-.89,1.44-1.92,1.82v.13h7.51c5.94,0,10.42-3.31,10.42-9.3,0-5.31-3.46-8.39-9.91-8.39Zm.61,17.27c-1.37,0-2.53-.3-3.49-.73V.87c.27-.2.53-.35.79-.47h1.08c5.26,0,7.51,3.84,7.51,9.38s-2.35,7.48-5.89,7.48Z" />
        <path d="m20.03,25.32v.54h-2.39v-.48c.91-.59,1.68-1.29,1.68-1.92,0-.35-.2-.56-.53-.56-.37,0-.58.25-.61.7l-.57-.04c0-.71.49-1.22,1.19-1.22.65,0,1.09.45,1.09,1.1,0,.75-.52,1.31-1.32,1.89h1.46Z" />
        <path d="m21.23,24.1c0-.73.13-1.78,1.19-1.78s1.2,1.03,1.2,1.78-.16,1.8-1.19,1.8-1.2-1.05-1.2-1.81Zm1.8.02c0-.71-.12-1.25-.61-1.25s-.6.57-.6,1.24.1,1.23.61,1.23.6-.55.6-1.23Z" />
        <path d="m27.23,25.32v.54h-2.39v-.48c.91-.59,1.68-1.29,1.68-1.92,0-.35-.2-.56-.53-.56-.37,0-.58.25-.61.7l-.57-.04c0-.71.49-1.22,1.19-1.22.65,0,1.09.45,1.09,1.1,0,.75-.52,1.31-1.32,1.89h1.46Z" />
        <path d="m30.46,24.5h.48v.54h-.48v.82h-.58v-.82h-1.57v-.53l1.56-2.14h.59v2.13Zm-1.54,0h.96v-1.35l-.96,1.35Z" />
      </g>
    </S.Svg>
  );
}

export function LinkedIn(props) {
  return (
    <S.Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 0.367188V19.7475H19.3803V0.367188H0ZM6.46009 15.7099H4.03756V6.82728H6.46009V15.7099ZM5.24883 5.80336C4.46877 5.80336 3.83568 5.16542 3.83568 4.37891C3.83568 3.59239 4.46877 2.95446 5.24883 2.95446C6.02888 2.95446 6.66197 3.59239 6.66197 4.37891C6.66197 5.16542 6.02969 5.80336 5.24883 5.80336ZM16.1502 15.7099H13.7277V11.1846C13.7277 8.46492 10.4977 8.67083 10.4977 11.1846V15.7099H8.07512V6.82728H10.4977V8.25254C11.6257 6.16431 16.1502 6.01008 16.1502 10.2519V15.7099Z"
        fill={props.colour ? props.colour : u.colours.charcoal}
      />
    </S.Svg>
  );
}

export function Location(props) {
  return (
    <S.Svg
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill={props.colour}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 6.75A5.246 5.246 0 019 1.5a5.246 5.246 0 015.25 5.25C14.25 10.688 9 16.5 9 16.5s-5.25-5.813-5.25-9.75zm3.375 0a1.876 1.876 0 103.751-.001 1.876 1.876 0 00-3.751.001z"
        fill={props.colour}
      ></path>
    </S.Svg>
  );
}

export function Lock(props) {
  return (
    <S.Svg
      width={props.width || "10"}
      height={props.height || "14"}
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 5.24902H8.125V3.99902C8.125 2.27402 6.725 0.874023 5 0.874023C3.275 0.874023 1.875 2.27402 1.875 3.99902V5.24902H1.25C0.5625 5.24902 0 5.81152 0 6.49902V12.749C0 13.4365 0.5625 13.999 1.25 13.999H8.75C9.4375 13.999 10 13.4365 10 12.749V6.49902C10 5.81152 9.4375 5.24902 8.75 5.24902ZM3.12397 3.99902C3.12397 2.96152 3.96147 2.12402 4.99897 2.12402C6.03647 2.12402 6.87397 2.96152 6.87397 3.99902V5.24902H3.12397V3.99902ZM6.25023 9.62402C6.25023 10.3115 5.68773 10.874 5.00023 10.874C4.31273 10.874 3.75023 10.3115 3.75023 9.62402C3.75023 8.93652 4.31273 8.37402 5.00023 8.37402C5.68773 8.37402 6.25023 8.93652 6.25023 9.62402Z"
        fill={props.fill || "currentColor"}
      />
    </S.Svg>
  );
}

export function Message(props) {
  return (
    <S.Svg viewBox="0 0 28 28" height="28" width="28" fill="black" {...props}>
      <path d="M14 2.042c6.76 0 12 4.952 12 11.64S20.76 25.322 14 25.322a13.091 13.091 0 0 1-3.474-.461.956 .956 0 0 0-.641.047L7.5 25.959a.961.961 0 0 1-1.348-.849l-.065-2.134a.957.957 0 0 0-.322-.684A11.389 11.389 0 0 1 2 13.682C2 6.994 7.24 2.042 14 2.042ZM6.794 17.086a.57.57 0 0 0 .827.758l3.786-2.874a.722.722 0 0 1 .868 0l2.8 2.1a1.8 1.8 0 0 0 2.6-.481l3.525-5.592a.57.57 0 0 0-.827-.758l-3.786 2.874a.722.722 0 0 1-.868 0l-2.8-2.1a1.8 1.8 0 0 0-2.6.481Z" />
    </S.Svg>
  );
}

export function Pandora(props) {
  return (
    <S.Svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 108.22 22.49"
      {...props}
    >
      <g id="Layer_2-2">
        <polygon points="67.9 3.91 68.35 3.91 68.37 3.88 67.99 .02 67.97 0 67.86 0 67.83 .02 67.43 3.88 67.45 3.91 67.9 3.91" />
        <polygon points="70.08 4.15 70.1 4.13 70.75 .67 70.73 .65 70.62 .63 70.6 .65 69.16 3.93 69.18 3.95 70.08 4.15" />
        <path d="m69.41,5.63c.27,0,.52-.22.52-.54,0-.29-.25-.52-.52-.52-.29,0-.54.22-.54.52,0,.31.25.54.54.54Z" />
        <path d="m67.9,5.48c.27,0,.52-.22.52-.54,0-.29-.25-.52-.52-.52-.29,0-.54.22-.54.52,0,.31.25.54.54.54Z" />
        <polygon points="65.72 4.15 66.62 3.95 66.64 3.93 65.21 .65 65.19 .63 65.07 .65 65.05 .67 65.7 4.13 65.72 4.15" />
        <path d="m65.86,5.1c0,.31.25.54.54.54.27,0,.52-.22.52-.54,0-.29-.25-.52-.52-.52-.29,0-.54.22-.54.52Z" />
        <path d="m4.6,6.6H.02l-.02.02s.11,1.1.11,3.01v9.65c0,1.91-.11,3.01-.11,3.01l.02.02h3.01l.02-.02s-.11-1.1-.11-3.01v-2.83l.02-.02c.4.04,1.32.09,1.64.09,3.1,0,5.75-1.89,5.75-5.07s-2.67-4.85-5.75-4.85Zm-.13,7.34c-.36,0-1.17-.04-1.53-.11v-4.65h1.75c1.55,0,2.78.63,2.78,2.27s-1.08,2.49-3.01,2.49Z" />
        <path d="m18.94,7.88c-.34-.79-.45-1.26-.45-1.26l-.02-.02h-2.45l-.02.02s-.09.47-.43,1.26l-5.3,12.75c-.45,1.08-.9,1.66-.9,1.66v.02h3.1l.02-.02c0-.09.07-.47.45-1.41l.97-2.4h6.82l1.03,2.4c.34.92.54,1.41.54,1.41l.02.02h3.1v-.02s-.4-.58-.9-1.66l-5.59-12.75Zm-3.97,8.01l2.22-5.54h.02l2.4,5.54h-4.65Z" />
        <path d="m40.93,6.62l-.02-.02h-2.74l-.02.02s.11,1.1.11,3.01v7.9h-.02l-8.49-10.93h-3.01l-.02.02c.34.72.52,1.21.52,1.55v11.11c0,1.91-.11,3.01-.11,3.01l.02.02h2.74l.02-.02s-.11-1.1-.11-3.01v-8.06h.02l8.53,11.09h2.56l.02-.02s-.11-1.1-.11-3.01v-9.65c0-1.91.11-3.01.11-3.01Z" />
        <path d="m49.46,6.6h-5.25l-.02.02s.11,1.1.11,3.01v9.65c0,1.91-.11,3.01-.11,3.01l.02.02h1.62c1.06,0,2.24.13,3.59.13,4.83,0,8.24-3.41,8.24-7.97s-3.34-7.88-8.19-7.88Zm-.18,13.27c-.76,0-1.46-.02-1.86-.13-.25-.07-.29-.16-.29-.58v-9.99h2.09c3.39,0,5.57,2.29,5.57,5.34s-2.18,5.36-5.5,5.36Z" />
        <path d="m67.9,6.38c-4.53,0-8.06,3.5-8.06,8.06s3.52,8.06,8.06,8.06,8.06-3.48,8.06-8.06-3.48-8.06-8.06-8.06Zm0,13.54c-2.92,0-5.19-2.38-5.19-5.48s2.27-5.48,5.19-5.48,5.21,2.38,5.21,5.48-2.27,5.48-5.21,5.48Z" />
        <path d="m87.16,16.97c-.38-.63-.97-1.12-1.55-1.28v-.02c1.64-.36,3.17-2.27,3.17-4.18,0-2.6-2-4.89-5.07-4.89h-5.03l-.02.02s.11,1.1.11,3.01v9.65c0,1.91-.11,3.01-.11,3.01l.02.02h3.01l.02-.02s-.11-1.1-.11-3.01v-3.01c1.5,0,2.09.29,2.63,1.14l1.28,2.07c1.06,1.71,1.5,2.81,1.5,2.81l.02.02h3.59v-.02s-.9-1.1-1.93-2.81l-1.53-2.51Zm-4.15-3.19c-.36,0-.99,0-1.41-.09v-4.53h1.73c1.68,0,2.58,1.1,2.58,2.36,0,1.19-.92,2.27-2.9,2.27Z" />
        <path d="m107.32,20.63l-5.59-12.75c-.34-.79-.45-1.26-.45-1.26l-.02-.02h-2.45l-.02.02s-.09.47-.43,1.26l-5.3,12.75c-.45,1.08-.9,1.66-.9,1.66v.02h3.1l.02-.02c0-.09.07-.47.45-1.41l.97-2.4h6.82l1.03,2.4c.34.92.54,1.41.54,1.41l.02.02h3.1v-.02s-.4-.58-.9-1.66Zm-9.56-4.74l2.22-5.54h.02l2.4,5.54h-4.65Z" />
      </g>
    </S.Svg>
  );
}

export function Pencil(props) {
  return (
    <S.Svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={props.color}
    >
      <path
        d="M5.72 15.4558L7.481 14.9478L18.084 4.21785C18.1676 4.13214 18.2142 4.01698 18.2136 3.89723C18.2131 3.77748 18.1654 3.66276 18.081 3.57785L17.446 2.93585C17.405 2.89368 17.3559 2.86012 17.3018 2.8371C17.2477 2.81409 17.1895 2.8021 17.1306 2.80182C17.0718 2.80154 17.0135 2.81298 16.9591 2.83548C16.9048 2.85797 16.8554 2.89107 16.814 2.93285L6.239 13.6348L5.719 15.4548L5.72 15.4558ZM18.703 1.66385L19.338 2.30685C20.214 3.19385 20.222 4.62485 19.354 5.50285L8.428 16.5608L4.664 17.6448C4.4342 17.7092 4.18826 17.6797 3.98016 17.5629C3.77206 17.4461 3.6188 17.2515 3.554 17.0218C3.50578 16.8567 3.50509 16.6813 3.552 16.5158L4.647 12.6758L15.544 1.64685C15.7512 1.4382 15.9979 1.27291 16.2696 1.1606C16.5414 1.04829 16.8328 0.991215 17.1269 0.992704C17.4209 0.994194 17.7117 1.05422 17.9823 1.16927C18.2529 1.28433 18.4979 1.45312 18.703 1.66385ZM7.184 2.81685C7.68 2.81685 8.082 3.22385 8.082 3.72585C8.08279 3.84451 8.06018 3.96217 8.01547 4.0721C7.97076 4.18202 7.90481 4.28206 7.82141 4.36648C7.73801 4.4509 7.63879 4.51806 7.52942 4.5641C7.42004 4.61015 7.30267 4.63419 7.184 4.63485H3.592C2.6 4.63485 1.796 5.44885 1.796 6.45185V17.3578C1.796 18.3618 2.6 19.1758 3.592 19.1758H14.368C15.36 19.1758 16.165 18.3618 16.165 17.3578V13.7228C16.165 13.2208 16.567 12.8138 17.063 12.8138C17.559 12.8138 17.961 13.2208 17.961 13.7238V17.3578C17.961 19.3658 16.352 20.9938 14.368 20.9938H3.592C1.608 20.9938 0 19.3658 0 17.3578V6.45185C0 4.44485 1.608 2.81685 3.592 2.81685H7.184Z"
        fill="currentColor"
      />
    </S.Svg>
  );
}

export function Phone(props) {
  return (
    <S.Svg height="24" width="24" fill={"white"} viewBox="0 0 32 32" {...props}>
      <path d="M16 11.175l.009 4.091c1.077 0 4.431.265 4.431.835s-.08 2.52.159 2.876c.635.953 2.879 2.563 4.12 2.579 1.88.024 5.048-2.909 4.565-4.939-.704-2.955-8.02-5.949-13.285-5.949v.005c-5.265 0-12.579 2.989-13.283 5.944-.483 2.029 2.685 4.963 4.565 4.939 1.241-.016 3.485-1.625 4.12-2.579.239-.356.159-2.307.159-2.876s3.369-.836 4.447-.836l-.005-4.089z" />
    </S.Svg>
  );
}

export function PhoneUp(props) {
  return (
    <svg
      style={{ transform: `rotate(225deg) scale(${props.grow || 1})` }}
      fill={"white"}
      height="24"
      width="24"
      viewBox="0 0 32 32"
    >
      <path d="M16 11.175l.009 4.091c1.077 0 4.431.265 4.431.835s-.08 2.52.159 2.876c.635.953 2.879 2.563 4.12 2.579 1.88.024 5.048-2.909 4.565-4.939-.704-2.955-8.02-5.949-13.285-5.949v.005c-5.265 0-12.579 2.989-13.283 5.944-.483 2.029 2.685 4.963 4.565 4.939 1.241-.016 3.485-1.625 4.12-2.579.239-.356.159-2.307.159-2.876s3.369-.836 4.447-.836l-.005-4.089z" />
    </svg>
  );
}

export function Plane(props) {
  return (
    <S.Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M13.9768 7.5656C14.0474 7.47464 14.0821 7.36038 14.0742 7.24499C14.0662 7.1296 14.0162 7.02131 13.9338 6.94114C13.8514 6.86097 13.7425 6.81463 13.6282 6.81112C13.514 6.80762 13.4025 6.84719 13.3154 6.92216L5.50439 13.6459C5.22372 13.8875 4.83249 13.9542 4.48761 13.8193L0.682438 12.3303C0.492523 12.2567 0.327466 12.1296 0.206881 11.9639C0.0862958 11.7982 0.0152526 11.601 0.00219295 11.3957C-0.0108667 11.1904 0.0346061 10.9856 0.133209 10.8057C0.231811 10.6257 0.379398 10.4782 0.55843 10.3806L18.6828 0.108129C18.8252 0.0304941 18.9858 -0.00655031 19.1474 0.00094939C19.3091 0.00844909 19.4656 0.0602115 19.6005 0.150712C19.7353 0.241212 19.8433 0.367054 19.9129 0.514806C19.9826 0.662558 20.0113 0.826675 19.996 0.989642L18.4061 17.7577C18.3902 17.9297 18.3348 18.0955 18.2444 18.242C18.154 18.3885 18.031 18.5117 17.8853 18.6017C17.7396 18.6916 17.5751 18.7459 17.405 18.7603C17.2348 18.7746 17.0637 18.7486 16.9053 18.6842L12.1837 16.8345C11.8226 16.693 11.4123 16.7731 11.1309 17.0399L8.2565 19.7652C8.1334 19.8816 7.97928 19.9589 7.81321 19.9876C7.64714 20.0163 7.47641 19.995 7.32212 19.9266C7.16784 19.8581 7.03677 19.7454 6.94514 19.6024C6.85351 19.4593 6.80533 19.2922 6.80656 19.1218V16.9856C6.80656 16.7605 6.88246 16.5421 7.022 16.3655L13.9768 7.5656Z" />
    </S.Svg>
  );
}

export function Play(props) {
  return (
    <S.Svg
      viewBox="0 0 100 100"
      fill="none"
      color="rgba(65, 65, 67, 1)"
      width="100"
      height="100"
      {...props}
    >
      <path
        d="M50 8.335c-23 0-41.667 18.667-41.667 41.667S27 91.668 50 91.668s41.667-18.666 41.667-41.666C91.667 27.002 73 8.335 50 8.335z"
        fill="#000"
        fillOpacity="0.6"
      />
      <path
        d="M37.5 37.511v24.973c0 1.92 2.021 3.17 3.739 2.311l24.973-12.487c1.904-.952 1.904-3.669 0-4.62L41.24 35.2c-1.718-.858-3.739.39-3.739 2.311z"
        fill="#fff"
      />
    </S.Svg>
  );
}

export function Plus(props) {
  return (
    <S.Svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      {...props}
    >
      <path
        d="M19 12a1 1 0 01-1 1h-5v5a1 1 0 11-2 0v-5H6a1 1 0 110-2h5V6a1 1 0 112 0v5h5a1 1 0 011 1z"
        fill="currentColor"
      />
    </S.Svg>
  );
}

export function Poll(props) {
  return (
    <S.Svg width="22" height="22" viewBox="0 0 24 24" {...props}>
      <path d="M20.222 9.16h-1.334c.015-.09.028-.182.028-.277V6.57c0-.98-.797-1.777-1.778-1.777H3.5V3.358c0-.414-.336-.75-.75-.75s-.75.336-.75.75V20.83c0 .415.336.75.75.75s.75-.335.75-.75v-1.434h10.556c.98 0 1.778-.797 1.778-1.777v-2.313c0-.095-.014-.187-.028-.278h4.417c.98 0 1.778-.798 1.778-1.778v-2.31c0-.983-.797-1.78-1.778-1.78zM17.14 6.293c.152 0 .277.124.277.277v2.31c0 .154-.125.28-.278.28H3.5V6.29h13.64zm-2.807 9.014v2.312c0 .153-.125.277-.278.277H3.5v-2.868h10.556c.153 0 .277.126.277.28zM20.5 13.25c0 .153-.125.277-.278.277H3.5V10.66h16.722c.153 0 .278.124.278.277v2.313z" />
    </S.Svg>
  );
}

export function PlusLocked(props) {
  return (
    <S.Svg width="19" height="26" {...props}>
      <polygon
        fill={u.colours.plusLime}
        points="0 0 0 21.38 9.12 25.28 18.25 21.38 18.25 0 0 0"
      />
      <path
        fill="#424143"
        d="M12.19,8.19v-.34c0-1.65-1.34-2.98-2.98-2.98h-.29c-1.65,0-2.98,1.34-2.98,2.98v.35c-.99,.12-1.76,.95-1.76,1.97v5.88c0,1.1,.89,1.99,1.99,1.99h5.88c1.1,0,1.99-.89,1.99-1.99v-5.88c0-1.05-.82-1.9-1.85-1.98Zm-3.27-2.32h.29c1.09,0,1.98,.89,1.98,1.98v.32H6.94v-.32c0-1.09,.89-1.98,1.98-1.98Z"
      />
      <path
        fill={u.colours.plusLime}
        d="M10.98,12.61h-1.37v-1.26c0-.28-.22-.5-.5-.5s-.5,.22-.5,.5v1.26h-1.37c-.28,0-.5,.22-.5,.5s.22,.5,.5,.5h1.37v1.48c0,.28,.22,.5,.5,.5s.5-.22,.5-.5v-1.48h1.37c.28,0,.5-.22,.5-.5s-.22-.5-.5-.5Z"
      />
    </S.Svg>
  );
}

export function PlusUnlocked(props) {
  return (
    <S.Svg width="19" height="26" {...props}>
      <polygon
        fill={u.colours.plusLime}
        points="0 0 0 21.38 9.12 25.28 18.25 21.38 18.25 0 0 0"
      />
      <path d="M12.04,18.55H6.18c-1.38,0-2.5-1.12-2.5-2.5v-5.87c0-1.38,1.12-2.5,2.5-2.5h5.87c1.38,0,2.5,1.12,2.5,2.5v5.87c0,1.38-1.12,2.5-2.5,2.5ZM6.18,8.68c-.83,0-1.5,.67-1.5,1.5v5.87c0,.83,.67,1.5,1.5,1.5h5.87c.83,0,1.5-.67,1.5-1.5v-5.87c0-.83-.67-1.5-1.5-1.5H6.18Z" />
      <path d="M6.88,8.18h-1v-2.19c0-1.71,1.39-3.09,3.09-3.09h1.18v1h-1.18c-1.15,0-2.09,.94-2.09,2.09v2.19Z" />
      <path d="M8.23,15.2s-.01,0-.02,0c-.11,0-.22-.06-.29-.14l-1.59-1.77c-.15-.17-.14-.44,.03-.59,.17-.15,.44-.14,.59,.03l1.31,1.46,3.07-2.83c.17-.16,.43-.14,.59,.02,.16,.17,.15,.43-.02,.59l-3.39,3.12c-.08,.07-.18,.11-.28,.11Z" />
    </S.Svg>
  );
}

export function ProfileMinus(props) {
  return (
    <S.Svg
      width="20"
      height="20"
      viewBox="0 0 159 116"
      fill={props.color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="101.5" cy="29.5" r="29.5" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158.882 105H159V97.5V97H158.79C143.748 62.2026 57.3286 64.6299 44.1961 97H44V97.5V105H44.1178C44.0403 105.489 44 105.99 44 106.5C44 111.747 48.2533 116 53.5 116H149.5C154.747 116 159 111.747 159 106.5C159 105.99 158.96 105.489 158.882 105Z"
        fill="currentColor"
      />
      <rect y="43" width="59" height="16" rx="8" fill="currentColor" />
    </S.Svg>
  );
}

export function ProfilePlus(props) {
  return (
    <S.Svg width="22" height="16" viewBox="0 0 22 16" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8C16.21 8 18 6.21 18 4C18 1.79 16.21 0 14 0C11.79 0 10 1.79 10 4C10 6.21 11.79 8 14 8ZM14 10C11.33 10 6 11.34 6 14V15C6 15.5523 6.44772 16 7 16H21C21.5523 16 22 15.5523 22 15V14C22 11.34 16.67 10 14 10ZM5 10C5 10.5523 4.55228 11 4 11C3.44772 11 3 10.5523 3 10V8H1C0.447715 8 0 7.55228 0 7C0 6.44772 0.447715 6 1 6H3V4C3 3.44772 3.44772 3 4 3C4.55228 3 5 3.44772 5 4V6H7C7.55228 6 8 6.44772 8 7C8 7.55228 7.55228 8 7 8H5V10Z"
        fill="currentColor"
      />
    </S.Svg>
  );
}

export function RibbonFilled(props) {
  return (
    <S.Svg width="19" height="26" {...props}>
      <polygon
        fill="#d68b76"
        points="18.5 25.5 9.5 18.5 .5 25.5 .5 .5 18.5 .5 18.5 25.5"
      />
    </S.Svg>
  );
}

export function RibbonUnfilled(props) {
  return (
    <S.Svg width="19" height="26" {...props}>
      <polygon
        stroke="#d68b76"
        fill="none"
        points="18.5 25.5 9.5 18.5 .5 25.5 .5 .5 18.5 .5 18.5 25.5"
      />
    </S.Svg>
  );
}

export function Rituals(props) {
  return (
    <S.Svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 192.13 22.47"
      {...props}
    >
      <g id="Layer_2-2">
        <path d="m15.82,10.88c0-3.24-2.27-5.67-5.96-5.67H1.97v8.45H0v2.91h1.97v5.22h3.06v-5.22h3.74l3.46,5.22h3.85l-4.14-5.92c2.21-.68,3.88-2.58,3.88-4.99m-10.78,2.78v-5.55h4.58c2.17,0,3.14,1.3,3.14,2.77s-.97,2.78-3.14,2.78h-4.58Z" />
        <rect x="23.98" y="5.27" width="3.06" height="16.58" />
        <polyline points="40.27 21.79 43.33 21.79 43.33 8.11 48.18 8.11 48.18 5.21 35.42 5.21 35.42 8.11 40.27 8.11 40.27 21.79" />
        <path d="m56.49,5.21v9.82c0,3.84,2.92,7.11,7.35,7.11s7.35-3.27,7.35-7.11V5.21h-3.06v9.16c0,3.04-1.9,4.86-4.29,4.86s-4.3-1.82-4.3-4.86V5.21h-3.06" />
        <path d="m81.32,5.21v2.75h3.8l-6.03,13.84h3.27l1.27-3.12h7.02l1.26,3.12h3.29l-7.01-16.58h-6.86m3.4,10.71l2.43-5.93,2.39,5.93h-4.83Z" />
        <polyline points="116.02 14.93 112.96 14.93 112.96 18.89 106.45 18.89 106.45 5.21 103.4 5.21 103.4 21.79 116.02 21.79 116.02 14.93" />
        <path d="m128.26,10.04c0-1,.96-2.24,3.48-2.24,1.6,0,2.97.5,4.48,1.98l2.27-2.03c-1.63-1.67-3.85-2.54-6.59-2.54-3.77,0-6.85,2.03-6.85,4.99,0,6.76,10.67,3.19,10.67,6.89,0,1.58-1.63,2.46-3.95,2.48-1.92,0-3.67-.93-4.91-2.24l-2.32,2.08c2.09,2.19,4.78,3.06,7.09,3.06,3.79,0,7.3-2.08,7.3-5.54,0-6.9-10.68-3.17-10.68-6.9" />
        <path d="m151.47,16.74c-1.45,0-2.62,1.18-2.62,2.64s1.18,2.64,2.62,2.64,2.64-1.19,2.64-2.64-1.18-2.64-2.64-2.64" />
        <path d="m166.48,16.74c-1.45,0-2.63,1.18-2.63,2.64s1.18,2.64,2.63,2.64,2.63-1.19,2.63-2.64-1.18-2.64-2.63-2.64" />
        <path d="m181.48,16.74c-1.45,0-2.63,1.18-2.63,2.64s1.18,2.64,2.63,2.64,2.64-1.19,2.64-2.64-1.18-2.64-2.64-2.64" />
        <path d="m186.38,2.84c0-.4.08-.78.23-1.12.15-.35.36-.65.62-.9.26-.25.57-.46.92-.6.35-.15.72-.22,1.11-.22s.76.07,1.1.22c.35.15.65.35.91.6.26.25.47.56.62.9.15.35.23.72.23,1.12s-.08.79-.23,1.14c-.15.35-.36.65-.62.91-.26.26-.56.46-.91.6-.35.15-.72.22-1.1.22s-.76-.07-1.11-.22c-.35-.15-.66-.35-.92-.6-.26-.26-.47-.56-.62-.91-.15-.35-.23-.73-.23-1.14Zm.52,0c0,.35.06.68.18.97.12.3.29.56.5.78.21.22.46.39.75.52.29.12.6.19.94.19s.64-.06.93-.19c.29-.12.53-.3.75-.52.21-.22.38-.48.5-.78.12-.3.18-.62.18-.97s-.06-.66-.18-.96c-.12-.3-.29-.55-.5-.77-.21-.22-.46-.39-.75-.51-.29-.12-.59-.19-.93-.19s-.65.06-.94.19c-.29.12-.54.3-.75.51-.21.22-.38.47-.5.77-.12.3-.18.61-.18.96Zm1.25-1.66h1.29c.4,0,.69.08.88.24.19.16.29.4.29.72,0,.3-.08.52-.25.66-.17.14-.38.22-.63.25l.96,1.48h-.56l-.91-1.44h-.55v1.44h-.52V1.19Zm.52,1.48h.54c.11,0,.22,0,.33-.01s.2-.03.28-.06c.08-.04.15-.09.2-.16.05-.07.07-.18.07-.31,0-.11-.02-.2-.06-.27-.04-.07-.1-.12-.17-.15-.07-.04-.15-.06-.24-.07-.09-.01-.18-.02-.26-.02h-.69v1.06Z" />
      </g>
    </S.Svg>
  );
}

export function Search(props) {
  return (
    <S.Svg viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="currentColor"
        d="M15.009 13.805h-.636l-.22-.219a5.184 5.184 0 0 0 1.256-3.386 5.207 5.207 0 1 0-5.207 5.208 5.183 5.183 0 0 0 3.385-1.255l.221.22v.635l4.004 3.999 1.194-1.195-3.997-4.007zm-4.808 0a3.605 3.605 0 1 1 0-7.21 3.605 3.605 0 0 1 0 7.21z"
      />
    </S.Svg>
  );
}

export function Share(props) {
  return (
    <S.Svg
      width="15"
      height="20"
      viewBox="0 0 15 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.5 8.13062H1.5C1.16667 8.13062 0.5 8.33062 0.5 9.13062C0.5 9.93062 0.5 15.4639 0.5 18.1306C0.5 18.4639 0.7 19.1306 1.5 19.1306C2.3 19.1306 9.83333 19.1306 13.5 19.1306C13.8333 19.1306 14.5 18.9306 14.5 18.1306C14.5 17.3306 14.5 11.7973 14.5 9.13062C14.5 8.79728 14.3 8.13062 13.5 8.13062C12.7 8.13062 11.8333 8.13062 11.5 8.13062M7.5 13.1306V3.13062M7.5 3.13062H8.5L7.5 1.63062L6.5 3.13062H7.5Z"
        stroke={u.colours.charcoal}
      />
    </S.Svg>
  );
}

export function Stats(props) {
  return (
    <S.Svg
      viewBox="0 0 24 24"
      color="rgb(224, 36, 94)"
      width="20"
      height="20"
      {...props}
    >
      <g>
        <path d="M12 22c-.414 0-.75-.336-.75-.75V2.75c0-.414.336-.75.75-.75s.75.336.75.75v18.5c0 .414-.336.75-.75.75zm5.14 0c-.415 0-.75-.336-.75-.75V7.89c0-.415.335-.75.75-.75s.75.335.75.75v13.36c0 .414-.337.75-.75.75zM6.86 22c-.413 0-.75-.336-.75-.75V10.973c0-.414.337-.75.75-.75s.75.336.75.75V21.25c0 .414-.335.75-.75.75z" />
      </g>
    </S.Svg>
  );
}

export function StepForward(props) {
  return (
    <S.Svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2444.95 1235.37"
      {...props}
    >
      <g id="Layer_2-2">
        <path d="m857.91,249.89c0,59.54-49.79,105.42-135.68,105.42-59.06,0-105.42-20.5-131.78-45.88l44.9-71.25c-6.34,67.35,51.24,109.33,106.4,109.33s68.81-41.97,68.81-67.84c0-43.44-32.7-55.64-90.78-69.3-94.68-21.97-120.55-71.26-120.55-113.23,0-60.04,51.24-97.12,129.82-97.12,56.61,0,97.12,19.52,122.99,44.41l-46.36,71.26c8.79-66.86-45.88-108.35-99.57-108.35-46.36,0-58.57,31.72-58.57,59.06,0,51.24,43.93,66.37,95.17,78.09,96.15,21.96,115.18,69.3,115.18,105.42Z" />
        <path d="m1184.46,217.18h-1.95c6.34-66.38-30.75-93.22-85.41-93.22h-18.54v301.62c0,22.45,17.08,27.82,46.85,30.26v2.44h-160.57v-2.44c29.77-2.44,46.85-7.81,46.85-30.26V123.97c-72.72.48-102,27.33-129.82,93.22h-1.95l16.11-100.54h319.68l-31.24,100.54Z" />
        <path d="m1532,245.49l-25.87,102.98-2.93,10.74-16.59-10.74h-258.67v-2.44c20.01-7.32,37.09-17.56,37.09-35.14V34.65c0-17.57-17.08-22.94-37.09-25.38v-2.44h268.43l18.06,85.89-1.95.98c-37.09-54.67-56.13-79.07-119.09-79.07h-61.49v159.11h40.99c60.52,0,83.46-13.18,95.17-58.08v123.48c-11.71-44.41-34.65-57.59-95.17-57.59h-40.99v159.1h64.42c62.95,0,93.71-30.75,133.73-96.14l1.95.97Z" />
        <path d="m1866.36,216.69c0,74.18-62.96,119.57-159.59,119.57h-56.13v94.2c0,17.57,17.08,22.94,37.09,25.38v2.44h-141.05v-2.44c20.01-2.44,37.09-7.81,37.09-25.38V144.46c0-17.57-17.08-22.94-37.09-25.38v-2.44h182.54c86.87,0,137.14,31.73,137.14,100.05Zm-65.89,22.94c0-56.13-15.13-115.18-98.1-115.18h-51.73v192.3c24.89,7.32,50.27,11.71,74.67,11.71,50.27,0,75.16-14.64,75.16-88.83Z" />
        <path d="m270.5,619.7l-1.9.95c-30.37-42.71-50.3-66.44-100.61-66.44h-88.27v159.45h75.93c47.93,0,59.8-12.81,71.18-45.56v98.71c-11.39-32.74-23.25-45.56-71.18-45.56h-75.93v130.5c0,17.08,16.61,22.3,36.07,24.68v2.37H0v-2.37c19.46-7.12,36.07-17.08,36.07-34.17v-268.6c0-17.08-16.61-22.3-36.07-24.68v-2.37h255.31l15.19,73.08Z" />
        <path d="m656.32,712.71c0,106.78-79.73,172.74-177.01,172.74s-177.96-65.96-177.96-172.74,79.73-172.74,177.96-172.74,177.01,65.96,177.01,172.74Zm-46.03,27.05c0-95.86-63.12-191.25-150.44-191.25-67.86,0-112,56-112,136.67,0,95.86,62.64,191.72,149.96,191.72,67.86,0,112.47-56,112.47-137.15Z" />
        <path d="m997.06,877.39v1.42h-81.15v-8.07l-93.49-129.08h-67.39v110.1c0,17.08,16.61,22.3,36.07,24.68v2.37h-115.79v-2.37c19.46-2.37,36.07-7.59,36.07-24.68v-278.09c0-17.08-16.61-22.3-36.07-24.68v-2.37h163.25c74.03,0,122.91,28.95,122.91,86.37,0,49.83-35.59,89.22-94.44,102.98l59.32,80.2c28,38.44,46.03,48.88,70.71,61.22Zm-167.52-144.27c61.69,0,89.22-17.08,89.22-83.05,0-46.51-14.24-94.91-105.83-94.91h-57.9v167.52c25.15,7.12,48.41,10.44,74.51,10.44Z" />
        <path d="m1501.52,546.62v1.9c-19.93,5.69-32.74,14.24-48.88,55.52l-101.08,258.64-43.19,29.9,1.42-9.97-68.81-177.96-59.32,158.03-43.19,29.9,1.42-9.97-117.22-303.72c-4.75-12.34-13.76-26.1-20.88-32.27h114.84v1.9c-33.22,2.85-52.2,12.81-36.07,55.05l94.44,250.1,60.74-162.3-43.19-112.47c-4.75-12.34-13.76-26.1-20.88-32.27h114.84v1.9c-33.22,2.85-52.2,12.81-36.07,55.05l94.44,250.1,97.29-250.1c16.14-41.29-1.42-49.35-28-55.05v-1.9h87.32Z" />
        <path d="m1780.09,876.91v1.9h-128.61v-1.9c33.22-2.85,52.2-13.29,35.59-55.05l-9.49-23.73h-186.98l-10.44,23.73c-17.56,40.81,1.42,49.35,28,55.05v1.9h-87.32v-1.9c19.93-5.69,31.32-14.71,48.88-55.52l105.83-244.4-.95-9.02,7.12-5.22,40.81-28.95c0,4.27.47,7.59,10.44,32.27l100.13,252.94c17.08,43.66,25.63,55.05,46.98,57.9Zm-105.83-87.32l-86.85-216.4-93.49,216.4h180.33Z" />
        <path d="m2118.45,877.39v1.42h-81.15v-8.07l-93.49-129.08h-67.39v110.1c0,17.08,16.61,22.3,36.07,24.68v2.37h-115.79v-2.37c19.46-2.37,36.07-7.59,36.07-24.68v-278.09c0-17.08-16.61-22.3-36.07-24.68v-2.37h163.25c74.03,0,122.91,28.95,122.91,86.37,0,49.83-35.59,89.22-94.44,102.98l59.32,80.2c28,38.44,46.03,48.88,70.71,61.22Zm-167.52-144.27c61.69,0,89.22-17.08,89.22-83.05,0-46.51-14.24-94.91-105.83-94.91h-57.9v167.52c25.15,7.12,48.41,10.44,74.51,10.44Z" />
        <path d="m2444.95,704.17c0,112.47-84,174.64-186.98,174.64h-137.15v-2.37c19.46-7.12,36.07-17.08,36.07-34.17v-268.6c0-17.08-16.61-22.3-36.07-24.68v-2.37h146.64c112.47,0,177.49,57.9,177.49,157.56Zm-47.46,24.68c0-100.13-42.24-174.64-149.01-174.64h-47.93v301.82c17.08,9.02,37.49,15.19,65.49,15.19,79.73,0,131.45-32.27,131.45-142.37Z" />
        <path d="m1674.06,1115.69v27.35c-1.13.22-2.79-1.15-4.29-2.01-9.82-5.83-23.69-11.56-39.99-9.5-15.83,1.96-27.55,11.64-32.32,25.3-5.85,16.76.05,34.55,9.73,43.39,9.66,8.86,27.73,14.05,44.06,7.91v-18.75h-21.7v-22.83h48.58v58.1c-18.67,11.67-53.34,13.55-75.04,3.38-20.32-9.57-35.62-28.75-35.69-56.72-.06-20.11,8.15-35.54,18.98-46.13,11.21-10.97,25.54-17.78,46.08-18.75,16.95-.78,30.33,3.32,41.6,9.26Z" />
        <path d="m909.97,1109.87h26.69c16.84,41.52,33.64,83.12,50.61,124.51-9.37.53-19.8.09-29.59.24-3.25-8.8-6.68-17.44-9.93-26.23h-49.75c-3.84,8.34-6.94,17.44-10.38,26.23h-28.46c17.01-41.52,33.63-83.42,50.82-124.75Zm-3.59,76.82c10.92-.13,22.42.32,32.97-.22-5.85-14.67-10.76-30.34-16.7-44.97-4.97,15.5-10.97,29.98-16.28,45.19Z" />
        <path d="m1014.59,1109.89h27.35v100.34c17.78.54,36.53.09,54.69.25v24.18h-82.28v-124.08c0-.32-.03-.64.24-.69Z" />
        <path d="m1132.08,1109.89h27.33v100.34c17.79.54,36.55.09,54.72.25v24.18h-82.31v-124.08c0-.32-.03-.64.26-.69Z" />
        <path d="m1247.42,1109.75c30.17.49,64.07-3.46,80.23,11.07,4.64,4.16,7.62,10.62,8.13,17.38,1.08,14.67-6.95,24.46-18.75,28.03,12.04,4.29,20.62,10.3,23.06,23.5,5.69,31.25-19.71,42.57-46.78,44.52-14.29,1.02-30.36-.29-46.1.24v-124.07c-.03-.35-.03-.66.21-.67Zm27.36,24.17v27.33c11.54.03,24.9,1.15,30.49-5.17,3.76-4.3,4.15-13.27,0-17.67-5.74-6.12-18.37-4.85-30.26-5.2-.27.03-.22.37-.22.7Zm0,46.97v30.07c13.62-.73,29.79,1.72,35.92-6.09,4.85-6.19,2.37-16.82-2.71-20.57-7.22-5.31-21.1-3.89-32.99-4.05-.27.03-.22.32-.22.64Z" />
        <path d="m1371.51,1109.89c30.42.59,62.9-3.52,80.71,10.19,8.75,6.76,13.46,18.56,11.74,32.77-1.75,14.46-11.34,24.86-24.64,28.94,10.59,17.48,23.92,35.45,34.59,52.87h-31.2c-11.21-15.93-21.07-33.17-32.08-49.29h-11.77v49.29h-27.57v-124.08c-.03-.32-.03-.64.22-.69Zm27.34,24.86v30.09c11.69-.3,25.64,1.13,32.77-4.07,4.3-3.16,7.03-11.45,3.87-18.11-4.8-9.92-21.41-8.39-36.42-8.58-.24.05-.24.38-.22.67Z" />
        <path d="m1504.93,1109.89h27.35v124.77h-27.57v-124.08c0-.32-.06-.64.22-.69Z" />
        <path d="m1718.41,1109.89h27.38v48.14h53.56c.53-15.59.06-32.16.22-48.14h27.57v124.77h-27.57v-52.43h-53.78v52.43h-27.6v-124.08c0-.32,0-.64.22-.69Z" />
        <path d="m1859.66,1109.89h108.06v24.19h-40.24c-.54,33.1-.09,67.13-.25,100.58h-27.55v-100.33c-12.98-.57-26.89-.09-40.25-.25v-23.5c0-.32-.03-.64.24-.69Z" />
        <circle cx="1998.71" cy="1220.52" r="14.85" />
        <path d="m527.99,1137.06l-28.85,26.93-15.39-2.99,16.46-45.09-23.51,21.16-29.92,26.93-15.39-2.99,32.48-88.9c1.71-4.7-2.56-9.4-18.81-14.32v-.43l42.1-1.07-6.84,15.81-31.2,85.48,30.35-27.78c9.4-8.55,17.52-16.03,23.93-22.87l12.82-34.83c1.71-4.7-2.56-9.4-18.81-14.32v-.43l42.1-1.07-6.84,15.81-31.2,85.27,29.28-27.57c56.85-53.43,58.98-67.1,15.6-72.02l.21-.43,47.02-1.07c8.98,10.47-2.56,22.44-65.61,80.78Z" />
        <path d="m586.11,1160.99l32.7-88.9c1.71-4.7-2.56-9.4-18.81-14.32v-.43l42.1-1.07-7.05,15.81-27.35,72.66c-.43,1.07-.43,1.28.64.64,6.62-3.85,14.75-10.47,22.44-17.74l.64.43-26.93,36.33-18.38-3.42Zm87.41-164.98l1.5,3.21-42.95,29.7-1.5-1.28,42.95-31.63Z" />
        <path d="m687.41,1062.48l-34.41,94.67,24.58-.85-.64.85-27.14,7.27h-4.49l-9.62-5.34,5.34-12.82,36.97-103.01c3.21-8.98-.43-7.91-22.44-.43l-.21-1.28,48.3-19.45-4.49,8.12-9.83,27.14h21.8l-2.99,5.13h-20.73Z" />
        <path d="m753.87,1040.04l-27.35,76.51,61.33-62.62c10.69-.43,18.38,1.92,16.88,5.98l-30.13,84.84c-.43,1.07,0,1.28.85.64,6.41-4.92,14.1-10.47,22.01-17.74l.21.43-26.5,36.33-18.59-3.42,32.7-90.18c1.07-2.78,3.63-7.05,2.14-7.05-2.99,0-14.32,8.12-64.11,61.55l-13.89,38.68-15.39-2.99,43.6-118.82c13.04-35.26,48.94-55.56,78.43-55.56,10.9,0,16.88,2.78,30.99,5.56l-17.31,12.39c-10.26-4.91-21.16-10.9-32.91-10.9-18.59,0-32.06,16.24-42.95,46.37Z" />
      </g>
    </S.Svg>
  );
}

export function Test(props) {
  return (
    <S.Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.1391 10.9359C17.1751 10.6359 17.1991 10.3239 17.1991 9.9999C17.1991 9.6759 17.1751 9.3639 17.1271 9.0639L19.1551 7.4799C19.3351 7.3359 19.3831 7.0719 19.2751 6.8679L17.3551 3.5439C17.2351 3.3279 16.9831 3.2559 16.7671 3.3279L14.3791 4.2879C13.8751 3.9039 13.3471 3.5919 12.7591 3.3519L12.3991 0.807902C12.3631 0.567902 12.1591 0.399902 11.9191 0.399902H8.07913C7.83913 0.399902 7.64713 0.567902 7.61113 0.807902L7.25113 3.3519C6.66313 3.5919 6.12313 3.9159 5.63113 4.2879L3.24313 3.3279C3.02713 3.2439 2.77513 3.3279 2.65513 3.5439L0.73513 6.8679C0.61513 7.0839 0.66313 7.3359 0.85513 7.4799L2.88313 9.0639C2.83513 9.3639 2.79913 9.6879 2.79913 9.9999C2.79913 10.3119 2.82313 10.6359 2.87113 10.9359L0.84313 12.5199C0.66313 12.6639 0.61513 12.9279 0.72313 13.1319L2.64313 16.4559C2.76313 16.6719 3.01513 16.7439 3.23113 16.6719L5.61913 15.7119C6.12313 16.0959 6.65113 16.4079 7.23913 16.6479L7.59913 19.1919C7.64713 19.4319 7.83913 19.5999 8.07913 19.5999H11.9191C12.1591 19.5999 12.3631 19.4319 12.3871 19.1919L12.7471 16.6479C13.3351 16.4079 13.8751 16.0839 14.3671 15.7119L16.7551 16.6719C16.9711 16.7559 17.2231 16.6719 17.3431 16.4559L19.2631 13.1319C19.3831 12.9159 19.3351 12.6639 19.1431 12.5199L17.1391 10.9359ZM9.99913 13.5999C8.01913 13.5999 6.39913 11.9799 6.39913 9.9999C6.39913 8.0199 8.01913 6.3999 9.99913 6.3999C11.9791 6.3999 13.5991 8.0199 13.5991 9.9999C13.5991 11.9799 11.9791 13.5999 9.99913 13.5999Z"
        fill={u.colours.charcoal}
      />
    </S.Svg>
  );
}

export function ThreeDots(props) {
  return (
    <S.Svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      color="rgba(65, 65, 67, 1)"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      />
    </S.Svg>
  );
}

export function Tick(props) {
  return (
    <S.Svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      color={u.colours.teal}
      {...props}
    >
      <path
        d="M4.91995 7.55559C4.63928 7.83597 4.18451 7.83585 3.90399 7.55533L2.30551 5.95686C2.02532 5.67667 1.57119 5.67618 1.29039 5.95576L0.455622 6.78693C0.173964 7.06738 0.173472 7.5232 0.454523 7.80425L3.90372 11.2535C4.18435 11.5341 4.63932 11.5341 4.91995 11.2535L13.492 2.68143C13.7726 2.40081 13.7726 1.94583 13.492 1.66521L12.6627 0.835974C12.3822 0.555454 11.9274 0.555337 11.6468 0.835712L4.91995 7.55559Z"
        fill={props.color || "currentColor"}
      />
    </S.Svg>
  );
}

export function TickForButton(props) {
  return (
    <S.Svg
      width="19"
      height="13"
      viewBox="0 0 19 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="9.84261"
        height="2.13886"
        rx="1.06943"
        transform="matrix(0.714629 0.699503 -0.714629 0.699503 1.5293 4.61891)"
        fill="white"
      />
      <rect
        width="16.4458"
        height="2.13886"
        rx="1.06943"
        transform="matrix(0.714629 -0.699504 0.714629 0.699503 5.7207 11.5039)"
        fill="white"
      />
    </S.Svg>
  );
}

export function TickRound(props) {
  return (
    <S.Svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 15C0 6.71573 6.71573 0 15 0V0C23.2843 0 30 6.71573 30 15V15C30 23.2843 23.2843 30 15 30V30C6.71573 30 0 23.2843 0 15V15Z"
        fill={props.fill ?? u.colours.teal}
      />
      <rect
        width="6.42063"
        height="1.39524"
        rx="0.69762"
        transform="matrix(0.714629 0.699503 -0.714629 0.699503 9.86914 14.3033)"
        fill={props.tick ?? "white"}
      />
      <rect
        width="10.7281"
        height="1.39524"
        rx="0.69762"
        transform="matrix(0.714629 -0.699504 0.714629 0.699503 12.6035 18.7946)"
        fill={props.tick ?? "white"}
      />
    </S.Svg>
  );
}

export function Ticks(props) {
  return (
    <S.Svg viewBox="0 0 16 15" width="16" height="15" {...props}>
      <path
        fill="currentColor"
        d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"
      />
    </S.Svg>
  );
}

export function Tissot(props) {
  return (
    <S.Svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 140.22 18.48"
      {...props}
    >
      <g id="Layer_2-2">
        <path d="m40.57,18.48h-18.96V.31h18.96v18.16Zm-2.71-7.1s.03-.09.03-.14c0-1.23,0-2.46,0-3.69,0-.04-.02-.09-.04-.13-.07,0-.13,0-.2,0-1.53,0-3.07,0-4.6,0h0V2.62h-4.01v4.78h0c-1.55,0-3.1,0-4.65,0-.06,0-.12.02-.18.03,0,1.31,0,2.62,0,3.93.06.01.12.04.18.04,1.55,0,3.1,0,4.65,0,0,0,0,0,0,0,0,1.56,0,3.12,0,4.68,0,.04.02.07.03.11h0c.06.02.12.04.17.04,1.2,0,2.4,0,3.6,0,.06,0,.12-.02.17-.03h0c.01-.05.03-.1.03-.15,0-.27,0-.54,0-.81,0-1.28,0-2.56,0-3.84h0c1.54,0,3.08,0,4.62,0,.06,0,.12-.02.18-.03,0,0,0,0,0,0Z" />
        <path d="m18.96,18.48H0V.31h18.96v18.17ZM16.45,1.95h0c-.05,0-.1-.03-.15-.03-4.56,0-9.12,0-13.67,0-.05,0-.1.02-.15.03,0,.06,0,.12,0,.18,0,1.25,0,2.5,0,3.75,0,.01,0,.02.01.03h4.5v11.18c.05,0,.1,0,.14,0,1.6,0,3.21,0,4.81,0,0-.01,0-.02.01-.03,0-.07,0-.13,0-.2,0-3.34,0-6.68,0-10.01,0-.3,0-.59,0-.89l.02-.03c.07,0,.13,0,.2,0,1.42,0,2.84,0,4.27,0,.01-.05.03-.1.03-.15,0-1.23,0-2.45,0-3.68,0-.05-.02-.09-.02-.14Z" />
        <path d="m114.74,18.18c-.35,0-.7.02-1.04,0-.48-.04-.96-.12-1.44-.19-.26-.04-.52-.06-.76-.14-.44-.13-.88-.28-1.3-.46-.33-.14-.65-.3-.96-.49-.66-.41-1.26-.89-1.72-1.52-.16-.22-.35-.41-.49-.64-.22-.34-.44-.68-.62-1.05-.17-.35-.32-.72-.44-1.1-.13-.4-.22-.81-.3-1.22-.07-.34-.12-.69-.14-1.03-.03-.76-.04-1.51-.04-2.27,0-.2.06-.4.09-.6.03-.21.03-.42.07-.63.08-.39.15-.79.27-1.17.22-.67.49-1.33.87-1.93.23-.36.52-.68.78-1.02.44-.56,1-.99,1.59-1.37.51-.32,1.04-.6,1.62-.77.59-.17,1.18-.37,1.79-.46.86-.13,1.73-.19,2.61-.11.44.04.89.04,1.32.11.58.1,1.16.22,1.73.39.48.14.95.35,1.4.57.57.27,1.08.65,1.55,1.08.58.53,1.07,1.14,1.45,1.83.4.73.69,1.51.86,2.33.11.54.21,1.08.22,1.63.02.64.05,1.27.02,1.91-.05,1.06-.21,2.1-.56,3.11-.28.8-.69,1.54-1.22,2.21-.63.79-1.39,1.42-2.28,1.91-.55.3-1.14.53-1.75.7-.54.15-1.09.25-1.64.31-.52.06-1.05.07-1.57.11,0-.01,0-.02,0-.03Zm-.16-14.01s0-.03,0-.04c-.31.05-.63.07-.94.14-.77.17-1.38.6-1.83,1.24-.55.76-.73,1.66-.8,2.57-.05.68-.03,1.37,0,2.05.02.4.1.81.19,1.2.16.7.45,1.33.98,1.84.49.47,1.08.77,1.74.87.46.07.95.06,1.41,0,.84-.09,1.55-.48,2.09-1.14.36-.45.56-.97.67-1.52.11-.57.18-1.14.23-1.71.05-.64.02-1.28-.05-1.92-.06-.5-.16-.98-.33-1.45-.3-.79-.82-1.39-1.57-1.77-.55-.28-1.15-.4-1.77-.36Z" />
        <path d="m96.09.03c1.02,0,2.03.13,3,.44.89.28,1.72.7,2.35,1.42.58.66.95,1.43,1.17,2.28.1.4.18.81.27,1.24h-5.16c-.1-.28-.18-.58-.31-.85-.28-.57-.74-.94-1.34-1.11-.61-.18-1.24-.18-1.86-.03-.6.14-.98.54-1.08,1.15-.05.3.09.55.3.77.27.27.61.41.97.5.58.15,1.17.28,1.75.42.45.11.9.23,1.35.35.48.13.96.26,1.43.41,1.23.4,2.4.92,3.31,1.89.58.63.96,1.38,1.1,2.22.08.43.11.88.1,1.32-.03.96-.31,1.85-.82,2.68-.47.76-1.09,1.38-1.84,1.86-.46.29-.95.53-1.47.69-.42.12-.85.25-1.28.34-.27.06-.55.07-.83.11-.12.02-.23.06-.34.08-.07.01-.13,0-.2,0-.82,0-1.63,0-2.45,0-.2,0-.4-.06-.61-.08-.21-.03-.42-.04-.62-.08-.36-.06-.73-.12-1.08-.21-.31-.08-.6-.2-.9-.32-1-.38-1.78-1.03-2.36-1.92-.13-.2-.28-.38-.39-.59-.08-.15-.13-.31-.19-.47-.09-.25-.19-.5-.27-.75-.09-.29-.16-.59-.25-.88-.01-.05-.05-.09-.07-.13.1-.28-.09-.55-.06-.85.06,0,.13,0,.19,0,1.62,0,3.23,0,4.85,0,.16,0,.19.05.23.2.07.33.15.66.29.97.36.81.99,1.33,1.84,1.56.23.06.48.07.71.07.38,0,.77.03,1.14-.09.52-.17.96-.43,1.24-.92.14-.24.21-.48.21-.75,0-.07-.03-.14-.05-.22,0-.04.04-.11.01-.16-.05-.12-.13-.23-.2-.34-.05-.09-.08-.19-.14-.27-.21-.27-.48-.46-.81-.58-.34-.13-.68-.26-1.03-.38-.16-.05-.33-.05-.49-.09-.13-.03-.24-.09-.37-.12-.11-.03-.22-.03-.33-.06-.09-.02-.18-.05-.27-.07-.43-.12-.86-.22-1.28-.36-.55-.18-1.1-.38-1.65-.59-.7-.27-1.34-.64-1.92-1.13-.42-.36-.79-.77-1.04-1.27-.16-.34-.29-.69-.42-1.04-.04-.12-.03-.26-.08-.38-.08-.2-.01-.39-.03-.59-.01-.21-.03-.43,0-.64.07-.47.19-.92.39-1.36.2-.44.45-.84.76-1.21.33-.38.71-.68,1.13-.95.54-.34,1.11-.59,1.72-.75.48-.12.97-.19,1.45-.27.81-.13,1.63-.12,2.44-.12.03,0,.07,0,.1,0,.01,0,.03,0,.04.01Z" />
        <path d="m86.22,12.6c-.03.23-.05.46-.1.69-.2.97-.63,1.83-1.27,2.59-.49.57-1.07,1.01-1.73,1.36-.62.33-1.29.56-1.98.69-.33.06-.66.13-1,.19-.02,0-.03,0-.05,0-.46.02-.92.05-1.37.06-.47.01-.95.01-1.42,0-.32-.01-.65-.06-.97-.1-.29-.03-.58-.06-.86-.1-.15-.02-.3-.06-.44-.1-.38-.11-.76-.21-1.13-.34-.47-.17-.91-.41-1.31-.71-.68-.5-1.15-1.17-1.55-1.89-.15-.27-.25-.58-.36-.87-.11-.32-.22-.64-.3-.97-.08-.33-.11-.67-.16-1.01,0-.05-.02-.1-.04-.17.06,0,.11,0,.16,0,1.64,0,3.29,0,4.93,0,.12,0,.17.03.18.16.09.67.33,1.28.8,1.78.38.41.85.69,1.41.8.6.12,1.21.14,1.81-.03.63-.18,1.14-.55,1.36-1.17.21-.58.08-1.22-.52-1.7-.22-.18-.48-.32-.75-.43-.42-.16-.85-.29-1.28-.41-.36-.1-.74-.16-1.1-.26-.58-.15-1.16-.29-1.72-.48-.58-.2-1.15-.42-1.7-.69-.76-.37-1.45-.85-1.98-1.52-.33-.42-.59-.88-.75-1.39-.11-.38-.2-.77-.18-1.17.02-.37,0-.74.07-1.1.08-.44.25-.86.46-1.26.21-.39.45-.76.76-1.07.35-.35.72-.67,1.17-.88.34-.16.66-.36,1-.49.4-.14.83-.25,1.25-.33.78-.16,1.57-.23,2.36-.21.01,0,.03-.01.04-.02.54.02,1.07.03,1.61.05.66.03,1.31.13,1.94.3,1.02.27,1.96.7,2.69,1.5.45.49.77,1.07,1,1.69.21.56.34,1.14.43,1.73,0,.04,0,.09,0,.14h-5.17c-.05-.2-.1-.4-.16-.6,0,0,0-.01,0-.01h0c-.14-.42-.39-.75-.74-1-.43-.3-.9-.49-1.44-.47-.38.01-.76,0-1.13.08-.6.13-.99.53-1.08,1.14-.03.21.02.45.18.65.27.33.63.49,1.02.6.52.15,1.05.3,1.58.39.19.03.38.08.56.13.95.26,1.89.54,2.83.81.24.07.49.11.71.22.35.17.68.37,1.01.58.33.2.65.41.95.65.17.13.28.33.42.49.17.21.37.41.5.65.13.24.2.52.29.78.07.19.15.37.19.56.04.17.03.35.04.53,0,.06.02.11.04.17,0,.1,0,.2,0,.3,0,.06,0,.11,0,.17,0,.12,0,.24-.01.36Z" />
        <path d="m134.67,4.66c0,.07,0,.13,0,.2,0,4.27,0,8.54,0,12.81v.21h-5.47v-.2c0-4.27,0-8.55,0-12.82,0-.07,0-.13,0-.2,0,0-.02-.02-.03-.03-1.1,0-2.2,0-3.3,0-.73,0-1.46,0-2.19,0,0,0-.02-.02-.03-.03,0-1.02,0-2.03,0-3.05,0-.41,0-.81,0-1.22,0,0,.02-.02.02-.02.05,0,.1,0,.15,0,5.41,0,10.81,0,16.22,0,.05,0,.1,0,.15,0,0,0,.02.02.03.03,0,1.13,0,2.26,0,3.39,0,.3,0,.59,0,.91-.07,0-.12,0-.18,0-1.72,0-3.44,0-5.16,0-.06,0-.12,0-.18,0,0,0-.02.02-.03.03Z" />
        <path d="m60.27.33c0,.18,0,.36,0,.54,0,1.18,0,2.36,0,3.54,0,.06,0,.12,0,.18,0,0-.02.02-.03.03-.18,0-.36,0-.55,0-1.59,0-3.18,0-4.77,0-.06,0-.12,0-.18,0,0,0-.02.02-.02.03,0,.07,0,.13,0,.2,0,4.27,0,8.54,0,12.81,0,.07,0,.13,0,.21h-5.47v-.2c0-4.27,0-8.55,0-12.82,0-.07,0-.13,0-.2,0,0-.02-.02-.03-.03-1.11,0-2.22,0-3.33,0-.72,0-1.45,0-2.17,0,0-.01-.02-.02-.02-.03,0-1.42,0-2.84,0-4.26,0,0,.02-.02.02-.03.05,0,.1,0,.15,0,5.41,0,10.81,0,16.22,0,.05,0,.1,0,.15,0,0,0,.02.02.03.02Z" />
        <path d="m62.34,17.85c0-.06,0-.12,0-.18,0-5.72,0-11.44,0-17.16,0-.07,0-.13,0-.21h5.46v17.57s-.07.01-.1.01c-1.75,0-3.5,0-5.25,0-.03,0-.05,0-.08,0,0-.01-.02-.02-.02-.03Z" />
        <path d="m86.22,12.6c0-.12,0-.24.01-.36.14.03.09.15.09.23,0,.05-.06.09-.1.13Z" />
        <path d="m86.23,12.07c0-.1,0-.2,0-.3.12.02.1.11.09.19,0,.04-.06.08-.09.11Z" />
        <path d="m123.64,4.6s.02.02.03.03c0,0-.02-.02-.03-.03Z" />
        <path d="m80.3,4.8h0s0,.02,0,.02c0,0,0,0,0-.02Z" />
        <path d="m134.67,4.66s.02-.02.03-.03c0,0-.02.02-.03.03Z" />
        <path d="m129.16,4.64s.02.02.03.03c0,0-.02-.02-.03-.03Z" />
        <path d="m54.72,4.66s.02-.02.02-.03c0,0-.02.02-.02.03Z" />
        <path d="m49.22,4.64s.02.02.03.03c0,0-.02-.02-.03-.03Z" />
        <path d="m60.24,4.62s.02-.02.03-.03c0,0-.02.02-.03.03Z" />
        <path d="m43.7,4.59s.02.02.02.03c0-.01-.02-.02-.02-.03Z" />
        <path d="m140.21.33s-.02-.02-.03-.03c0,0,.02.02.03.03Z" />
        <path d="m123.67.31s-.02.02-.02.02c0,0,.02-.02.02-.02Z" />
        <path d="m60.27.33s-.02-.02-.03-.02c0,0,.02.02.03.02Z" />
        <path d="m43.72.31s-.02.02-.02.03c0,0,.02-.02.02-.03Z" />
        <path d="m96.09.03s-.03,0-.04-.01c.01,0,.03,0,.04.01Z" />
        <path d="m77.95.02s-.03.01-.04.02c.01,0,.03-.01.04-.02Z" />
        <path d="m62.34,17.85s.02.02.02.03c0-.01-.02-.02-.02-.03Z" />
        <path d="m24.23,11.37c0-1.31,0-2.62,0-3.93,1.55,0,3.1,0,4.64,0,.06,0,.12-.02.18-.03,0,0,0,0,0,0,.01-.06.03-.12.03-.19,0-1.46,0-2.92,0-4.38,0-.06,0-.13,0-.19h3.94c0,.08,0,.14,0,.21,0,1.45,0,2.91,0,4.36,0,.06.02.12.03.19,0,0,0,0,0,0,.06.01.12.03.19.03,1.54,0,3.07,0,4.61,0v3.93s0,0,0,0c-1.54,0-3.08,0-4.62,0-.06,0-.12.02-.18.03,0,0,0,0,0,0,0,.06-.03.13-.03.19,0,1.53,0,3.07,0,4.6,0,0,0,0,0,0h-3.94s0,0,0,0c0-1.53,0-3.07,0-4.6,0-.06-.02-.13-.03-.19,0,0,0,0,0,0-.06-.01-.12-.03-.18-.03-1.55,0-3.1,0-4.65,0Z" />
        <path d="m33.06,7.41c-.01-.06-.03-.12-.03-.19,0-1.45,0-2.91,0-4.36,0-.06,0-.13,0-.21h-3.94c0,.06,0,.13,0,.19,0,1.46,0,2.92,0,4.38,0,.06-.02.12-.03.19,0-1.59,0-3.18,0-4.78h4.01v4.79Z" />
        <path d="m29.06,7.41c-.06.01-.12.03-.18.03-1.55,0-3.1,0-4.64,0,.06-.01.12-.03.18-.03,1.55,0,3.1,0,4.65,0Z" />
        <path d="m24.23,11.37c1.55,0,3.1,0,4.65,0,.06,0,.12.02.18.03-1.55,0-3.1,0-4.65,0-.06,0-.12-.02-.18-.04Z" />
        <path d="m29.06,11.41c0,.06.03.13.03.19,0,1.53,0,3.07,0,4.6-.01-.04-.03-.07-.03-.11,0-1.56,0-3.12,0-4.68Z" />
        <path d="m33.03,16.2c0-1.53,0-3.07,0-4.6,0-.06.02-.13.03-.19,0,1.28,0,2.56,0,3.84,0,.27,0,.54,0,.81,0,.05-.02.1-.03.15Z" />
        <path d="m37.86,7.44c-1.54,0-3.07,0-4.61,0-.06,0-.12-.02-.19-.03,1.53,0,3.07,0,4.6,0,.07,0,.13,0,.2,0,0,.01,0,.02,0,.03Z" />
        <path d="m33.06,11.41c.06-.01.12-.03.18-.03,1.54,0,3.08,0,4.62,0-.06.01-.12.03-.18.03-1.54,0-3.08,0-4.62,0Z" />
        <path d="m37.86,7.44s0-.02,0-.03c.01.04.04.09.04.13,0,1.23,0,2.46,0,3.69,0,.05-.02.09-.03.14,0-1.31,0-2.62,0-3.93Z" />
        <path d="m29.09,16.2h3.94c-.06.01-.12.03-.17.03-1.2,0-2.4,0-3.6,0-.06,0-.12-.02-.17-.03Z" />
        <path d="m11.95,5.95c0,.3,0,.59,0,.89,0,3.34,0,6.68,0,10.01,0,.07,0,.13,0,.2,0,.01,0,.02-.01.03-1.6,0-3.21,0-4.81,0-.04,0-.09,0-.14,0V5.92c-1.51,0-3.01,0-4.5,0,0-.01,0-.02-.01-.03,0-1.25,0-2.5,0-3.75,0-.06,0-.12,0-.18,4.14,0,8.28,0,12.42,0,.52,0,1.04,0,1.55,0,0,0,0,0,0,0,0,.07,0,.14,0,.21,0,1.25,0,2.5,0,3.75-1.42,0-2.84,0-4.27,0-.07,0-.13,0-.2,0,0,.01-.02.02-.02.03Z" />
        <path d="m16.45,1.95c-.52,0-1.04,0-1.55,0-4.14,0-8.28,0-12.42,0,.05-.01.1-.03.15-.03,4.56,0,9.12,0,13.67,0,.05,0,.1.02.15.03Z" />
        <path d="m16.44,5.91c0-1.25,0-2.5,0-3.75,0-.07,0-.14,0-.21,0,.05.02.09.02.14,0,1.23,0,2.45,0,3.68,0,.05-.02.1-.03.15Z" />
        <path d="m2.46,5.88s0,.02.01.03c0-.01,0-.02-.01-.03Z" />
        <path d="m11.95,5.95s.02-.02.02-.03c0,.01-.02.02-.02.03Z" />
        <path d="m11.94,17.09s0-.02.01-.03c0,.01,0,.02-.01.03Z" />
      </g>
    </S.Svg>
  );
}

export function Triangle(props) {
  return (
    <S.Svg
      viewBox="7 7 9 10"
      fill="none"
      color={props.colour || "rgba(65, 65, 67, 1)"}
      width={props.size || "11"}
      height={props.size || "11"}
      {...props}
    >
      <path d="m 9 17 l 5 -4 l -5 -4 v 8 z" fill="currentColor" />
    </S.Svg>
  );
}

export function TriangleDown(props) {
  return (
    <S.Svg
      viewBox="7 7 9 10"
      width="16"
      height="9"
      fill="none"
      color="rgba(65, 65, 67, 1)"
      {...props}
    >
      <path d="M8 9 .206 0h15.588L8 9Z" fill="currectColor" />
    </S.Svg>
  );
}

export function Twitter(props) {
  return (
    <S.Svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_522_15)">
        <path
          d="M13.843 9.31072L22.033 0H20.0922L12.9808 8.08436L7.30101 0H0.75L9.33902 12.225L0.75 21.9887H2.69088L10.2007 13.4513L16.199 21.9887H22.75L13.8425 9.31072H13.843ZM11.1847 12.3327L10.3144 11.1154L3.3902 1.42891H6.37127L11.9592 9.24619L12.8295 10.4635L20.0931 20.6248H17.1121L11.1847 12.3332V12.3327Z"
          fill={props.colour ? props.colour : u.colours.charcoal}
        />
      </g>
      <defs>
        <clipPath id="clip0_522_15">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(0.75)"
          />
        </clipPath>
      </defs>
    </S.Svg>
  );
}

export function TikTok(props) {
  return (
    <S.Svg
      width="23"
      height="25"
      viewBox="0 0 23 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_522_19)">
        <path
          d="M19.464 5.0111C18.1052 4.13286 17.1242 2.72824 16.8184 1.09071C16.7522 0.736743 16.716 0.372754 16.716 0H12.3787L12.3715 17.2252C12.2986 19.1541 10.6967 20.7023 8.73258 20.7023C8.12223 20.7023 7.54726 20.5512 7.04137 20.2869C5.8809 19.6817 5.0869 18.4762 5.0869 17.0891C5.0869 15.0968 6.72251 13.4759 8.73258 13.4759C9.10789 13.4759 9.46761 13.5373 9.80838 13.6429V9.25499C9.45582 9.20741 9.09778 9.17777 8.73258 9.17777C4.33123 9.17819 0.75 12.7271 0.75 17.0891C0.75 19.7656 2.0996 22.134 4.15811 23.5662C5.45463 24.4682 7.0321 25 8.733 25C13.1348 25 16.716 21.4511 16.716 17.0891V8.35462C18.4169 9.56472 20.5011 10.2777 22.75 10.2777V5.97951C21.5386 5.97951 20.4101 5.62262 19.464 5.0111Z"
          fill={props.colour ? props.colour : u.colours.charcoal}
        />
      </g>
      <defs>
        <clipPath id="clip0_522_19">
          <rect
            width="22"
            height="25"
            fill="white"
            transform="translate(0.75)"
          />
        </clipPath>
      </defs>
    </S.Svg>
  );
}

export function UpdateProfile(props) {
  return (
    <S.Svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 8.5C10.21 8.5 12 6.71 12 4.5C12 2.29 10.21 0.5 8 0.5C5.79 0.5 4 2.29 4 4.5C4 6.71 5.79 8.5 8 8.5ZM8 10.5C5.33 10.5 0 11.84 0 14.5V15.5C0 16.0523 0.447715 16.5 1 16.5H15C15.5523 16.5 16 16.0523 16 15.5V14.5C16 11.84 10.67 10.5 8 10.5Z"
        fill="currentColor"
      />
    </S.Svg>
  );
}

export function Write(props) {
  return (
    <S.Svg width="22" height="22" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={u.colours.charcoal}
        d="M4 2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2zm2 14h14V4H4v14l2-2z"
      />
    </S.Svg>
  );
}

type StyleProps = {
  grow?: number;
};

const S = () => {};

S.Svg = styled.svg<StyleProps>`
  ${(p) => p.grow && `transform: scale(${p.grow});`}
  overflow: visible;
`;
